(function () {
    'use strict';

    if (window.MightyWidgetsLoaded) {
        return;
    }
    window.MightyWidgetsLoaded = true;

    const MightyPublicApi = {
        baseUrl: 'https://mlapi.newmediaretailer.com/api/public',
        getShopDomain(shopDomain) {
            return shopDomain || window.Shopify?.shop || window.location.hostname.replace('www.', '');
        },
        getBaseUrl(apiBaseUrl) {
            if (!apiBaseUrl || apiBaseUrl.includes('local.newmediaretailer.com')) {
                return this.baseUrl;
            }

            return apiBaseUrl;
        },
        url(resource, shopDomain, params, apiBaseUrl) {
            const baseUrl = this.getBaseUrl(apiBaseUrl).replace(/\/+$/, '');
            const cleanResource = resource.replace(/^\/+|\/+$/g, '');
            const url = new URL(`${baseUrl}/${cleanResource}/`);
            url.searchParams.set('shop', this.getShopDomain(shopDomain));

            Object.entries(params || {}).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== '') {
                    url.searchParams.set(key, value);
                }
            });

            return url.toString();
        }
    };

    const MightyWidgetData = {
        locationsPromise: null,
        locationsPromises: {},
        normalizeArray(data, key) {
            if (Array.isArray(data?.[key])) return data[key];
            if (data?.[key] && typeof data[key] === 'object') return Object.values(data[key]);
            if (Array.isArray(data)) return data;
            if (data && typeof data === 'object') return Object.values(data);
            return [];
        },
        getLocations(shopDomain, apiBaseUrl) {
            const cacheKey = `${MightyPublicApi.getShopDomain(shopDomain)}|${MightyPublicApi.getBaseUrl(apiBaseUrl)}`;
            if (this.locationsPromises[cacheKey]) return this.locationsPromises[cacheKey];
            const embedded = window.mighty_local && Object.prototype.hasOwnProperty.call(window.mighty_local, 'locations') ? window.mighty_local.locations : null;
            if (typeof embedded !== 'undefined' && embedded !== null && embedded !== false) {
                this.locationsPromises[cacheKey] = Promise.resolve(this.normalizeArray(embedded, 'locations'));
                this.locationsPromise = this.locationsPromises[cacheKey];
                return this.locationsPromises[cacheKey];
            }
            this.locationsPromises[cacheKey] = fetch(MightyPublicApi.url('locations', shopDomain, null, apiBaseUrl), {
                method: 'GET',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
            }).then(response => {
                if (!response.ok) throw new Error(`Failed to load locations: ${response.status} ${response.statusText}`);
                return response.json();
            }).then(data => this.normalizeArray(data, 'locations'));
            this.locationsPromise = this.locationsPromises[cacheKey];
            return this.locationsPromises[cacheKey];
        }
    };

    function setMightyWidgetVariables(container, theme) {
        if (!container) return;
        const colors = window.mighty_local?.team_config?.colors || {};
        const dark = theme === 'dark';
        container.style.setProperty('--mighty-primary-color', colors.primary || '#3b82f6');
        container.style.setProperty('--mighty-secondary-color', colors.secondary || '#000000');
        container.style.setProperty('--mighty-text-color', dark ? '#f9fafb' : '#111827');
        container.style.setProperty('--mighty-muted-color', dark ? '#9ca3af' : '#6b7280');
        container.style.setProperty('--mighty-border-color', dark ? '#374151' : '#e5e7eb');
        container.style.setProperty('--mighty-card-bg', dark ? '#1f2937' : '#ffffff');
        container.style.setProperty('--mighty-hover-bg', dark ? '#374151' : '#f3f4f6');
        container.style.setProperty('--mighty-overlay-bg', dark ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.5)');
        container.style.setProperty('--mighty-error-bg', dark ? 'rgba(220, 38, 38, 0.1)' : 'rgba(254, 242, 242, 0.8)');
    }


    function run_offers() {
        setMightyWidgetVariables(document.getElementById((window.MightyOffersConfig || {}).containerId || 'mighty-offers-section'), (window.MightyOffersConfig || {}).theme || 'light');
'use strict';

    // Prevent conflicts with existing scripts
    if (window.MightyLocalOffersLoaded) {
        return;
    }
    window.MightyLocalOffersLoaded = true;

    // Configuration - customize these values as needed
    const userConfig = window.MightyOffersConfig || {};
    const config = {
        offersLimit: userConfig.offersLimit !== undefined ? userConfig.offersLimit : null, // null = no limit
        showOfferCode: userConfig.showOfferCode !== false,
        showExpiryDate: userConfig.showExpiryDate !== false,
        shopDomain: userConfig.shopDomain || window.Shopify?.shop || window.location.hostname.replace('www.', ''),
        title: userConfig.title || 'Special Offers',
        subtitle: userConfig.subtitle || 'Don\'t miss out on these amazing deals!',
        containerId: userConfig.containerId || 'mighty-offers-section',
        carousel: userConfig.carousel !== false,
        carouselAutoPlay: userConfig.carouselAutoPlay !== false,
        carouselSpeed: userConfig.carouselSpeed || 5000,
        itemsPerSlide: userConfig.itemsPerSlide || 3,
        showViewAllButton: userConfig.showViewAllButton !== false,
        viewAllButtonText: userConfig.viewAllButtonText || 'View All Offers',
        viewAllButtonUrl: userConfig.viewAllButtonUrl || '/apps/pages/offers',
        apiBaseUrl: userConfig.apiBaseUrl || MightyPublicApi.baseUrl
    };

    // Carousel state
    let currentSlide = 0;
    let totalSlides = 0;
    let allOffers = [];
    let lastWindowWidth = window.innerWidth;
    let secondaryColor = '#000000';

    // Get responsive items per slide based on screen size
    function getResponsiveItemsPerSlide() {
        const width = window.innerWidth;
        if (width < 768) {
            return 1; // Mobile: 1 item
        } else if (width >= 768 && width < 1024) {
            return 2; // Tablet: 2 items
        } else {
            return config.itemsPerSlide; // Desktop: user configured (default 3)
        }
    }

    // Inject CSS styles
    function injectStyles() {
        return;
    }

    // Function to decode HTML entities
    function decodeHtmlEntities(text) {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = text;
        return textarea.value;
    }

    // Function to strip HTML tags and decode entities
    function stripHtmlTags(html) {
        if (!html) return '';
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || '';
    }

    // Function to format date
    function formatDate(dateString) {
        if (!dateString) return '';
        if (dateString === 'Ongoing') return 'Ongoing';

        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
        } catch (e) {
            return dateString;
        }
    }

    // Function to create offer card HTML
    function createOfferCard(offer) {
        const hasCode = config.showOfferCode && offer.has_code && offer.code;
        const showDates = config.showExpiryDate && !offer.hide_dates;
        const hasValidFrom = showDates && offer.valid_from && offer.valid_from !== 'Ongoing';
        const hasValidUntil = showDates && offer.valid_until && offer.valid_until !== 'Ongoing';
        const imageUrl = offer.image_url || offer.image;

        // Format dates display
        let datesHtml = '';
        if (hasValidFrom && hasValidUntil) {
            datesHtml = `<span class="mighty-offer-dates">Valid: ${formatDate(offer.valid_from)} - ${formatDate(offer.valid_until)}</span>`;
        } else if (hasValidFrom) {
            datesHtml = `<span class="mighty-offer-dates">Valid From: ${formatDate(offer.valid_from)}</span>`;
        } else if (hasValidUntil) {
            datesHtml = `<span class="mighty-offer-expiry">Valid Until: ${formatDate(offer.valid_until)}</span>`;
        }

        return `
            <div class="mighty-offer-card">
                ${imageUrl ? `<img src="${imageUrl}" alt="${offer.title}" class="mighty-offer-image">` : ''}
                <div class="mighty-offer-content">
                    <h3 class="mighty-offer-title">${offer.title}</h3>
                    ${(offer.short_description || offer.description) ? `<p class="mighty-offer-description">${offer.short_description || stripHtmlTags(offer.description)}</p>` : ''}

                    ${(hasCode || datesHtml) ? `
                        <div class="mighty-offer-meta">
                            ${hasCode ? `<span class="mighty-offer-code">CODE: ${offer.code}</span>` : '<span></span>'}
                            ${datesHtml}
                        </div>
                    ` : ''}

                    <a href="/apps/pages/offers/${offer.id}" class="mighty-offer-button">
                        View Offer Details
                    </a>
                </div>
            </div>
        `;
    }

    // Function to chunk offers into slides
    function chunkOffers(offers, itemsPerSlide) {
        const chunks = [];
        for (let i = 0; i < offers.length; i += itemsPerSlide) {
            chunks.push(offers.slice(i, i + itemsPerSlide));
        }
        return chunks;
    }

    // Function to render carousel
    function renderCarousel(offers) {
        const itemsPerSlide = getResponsiveItemsPerSlide();

        // For 1-2 items on desktop, don't use carousel
        if (window.innerWidth >= 768 && offers.length <= 2) {
            return renderGrid(offers);
        }

        const slides = chunkOffers(offers, itemsPerSlide);
        totalSlides = slides.length;

        const slidesHtml = slides.map((slideOffers, index) => {
            const offersHtml = slideOffers.map(createOfferCard).join('');
            return `<div class="mighty-offers-slide">${offersHtml}</div>`;
        }).join('');

        const dotsHtml = slides.map((_, index) =>
            `<button class="mighty-carousel-dot ${index === 0 ? 'active' : ''}" data-slide="${index}" aria-label="Go to slide ${index + 1}" ${index === 0 ? 'aria-current="true"' : ''}></button>`
        ).join('');

        return `
            <div class="mighty-offers-carousel-wrapper">
                ${totalSlides > 1 ? `
                    <button class="mighty-carousel-arrow mighty-offers-carousel-arrow-prev" onclick="window.mightyOffersPrev()" style="display: none;" aria-label="Previous slide">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                        </svg>
                    </button>
                    <button class="mighty-carousel-arrow mighty-offers-carousel-arrow-next" onclick="window.mightyOffersNext()" aria-label="Next slide">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                        </svg>
                    </button>
                ` : ''}
                <div class="mighty-offers-carousel">
                    ${slidesHtml}
                </div>
            </div>
            ${totalSlides > 1 ? `
                <div class="mighty-carousel-dots">
                    ${dotsHtml}
                </div>
            ` : ''}
            ${config.showViewAllButton ? `
                <div class="mighty-view-all-container">
                    <a href="${config.viewAllButtonUrl}" class="mighty-view-all-button">
                        ${config.viewAllButtonText}
                    </a>
                </div>
            ` : ''}
        `;
    }

    // Function to render static grid
    function renderGrid(offers) {
        const offersHtml = offers.map(createOfferCard).join('');
        const itemClass = offers.length === 1 ? 'items-1' : offers.length === 2 ? 'items-2' : '';
        return `
            <div class="mighty-offers-grid ${itemClass}">${offersHtml}</div>
            ${config.showViewAllButton ? `
                <div class="mighty-view-all-container">
                    <a href="${config.viewAllButtonUrl}" class="mighty-view-all-button">
                        ${config.viewAllButtonText}
                    </a>
                </div>
            ` : ''}
        `;
    }

    // Function to update arrow states
    function updateArrowStates() {
        const prevArrow = document.querySelector('.mighty-offers-carousel-arrow-prev');
        const nextArrow = document.querySelector('.mighty-offers-carousel-arrow-next');

        if (prevArrow && nextArrow) {
            // Show/hide prev arrow based on current slide
            if (currentSlide === 0) {
                prevArrow.style.display = 'none';
            } else {
                prevArrow.style.display = 'flex';
            }

            // Show/hide next arrow based on current slide
            if (currentSlide === totalSlides - 1) {
                nextArrow.style.display = 'none';
            } else {
                nextArrow.style.display = 'flex';
            }
        }
    }

    // Function to go to specific slide
    function goToSlide(slideIndex) {
        currentSlide = slideIndex;
        const carousel = document.querySelector('.mighty-offers-carousel');
        const dots = document.querySelectorAll('.mighty-carousel-dot');

        if (carousel) {
            carousel.style.transform = `translateX(-${currentSlide * 100}%)`;
        }

        // Update dots
        dots.forEach((dot, index) => {
            if (index === currentSlide) {
                dot.classList.add('active');
                dot.setAttribute('aria-current', 'true');
            } else {
                dot.classList.remove('active');
                dot.removeAttribute('aria-current');
            }
        });

        // Update arrow states
        updateArrowStates();
    }

    // Function to go to next slide
    function nextSlide() {
        if (currentSlide < totalSlides - 1) {
            currentSlide++;
            goToSlide(currentSlide);
        }
    }

    // Function to go to previous slide
    function prevSlide() {
        if (currentSlide > 0) {
            currentSlide--;
            goToSlide(currentSlide);
        }
    }

    // Expose functions globally for onclick handlers
    window.mightyOffersNext = nextSlide;
    window.mightyOffersPrev = prevSlide;

    // Function to attach carousel event listeners
    function attachCarouselListeners() {
        const dots = document.querySelectorAll('.mighty-carousel-dot');
        const carouselWrapper = document.querySelector('.mighty-offers-carousel-wrapper');

        // Initialize arrow states on load
        updateArrowStates();

        dots.forEach(dot => {
            dot.addEventListener('click', () => {
                const slideIndex = parseInt(dot.getAttribute('data-slide'));
                goToSlide(slideIndex);
            });
        });

        // Touch/swipe support
        let touchStartX = 0;
        let touchEndX = 0;

        if (carouselWrapper) {
            carouselWrapper.addEventListener('touchstart', (e) => {
                touchStartX = e.changedTouches[0].screenX;
            });

            carouselWrapper.addEventListener('touchend', (e) => {
                touchEndX = e.changedTouches[0].screenX;
                handleSwipe();
            });
        }

        function handleSwipe() {
            if (touchEndX < touchStartX - 50) {
                nextSlide();
            }
            if (touchEndX > touchStartX + 50) {
                prevSlide();
            }
        }

        // Initialize arrow states
        updateArrowStates();
    }

    // Function to render the widget structure
    function renderWidget(container) {
        container.innerHTML = `
            <div class="mighty-offers-section">
                <div class="mighty-offers-container">
                    <div class="mighty-offers-header">
                        <h2 class="mighty-offers-title">${config.title}</h2>
                        <p class="mighty-offers-subtitle">${config.subtitle}</p>
                    </div>
                    <div id="mighty-offers-content" class="mighty-offers-loading">
                        <p>Loading offers...</p>
                    </div>
                </div>
            </div>
        `;
    }

    // Function to re-render carousel on resize
    function reRenderCarousel() {
        if (!config.carousel || allOffers.length === 0) {
            return;
        }

        const contentDiv = document.getElementById('mighty-offers-content');
        if (!contentDiv) {
            return;
        }

        // Reset current slide to 0
        currentSlide = 0;

        // Re-render with new items per slide
        contentDiv.innerHTML = renderCarousel(allOffers);

        // Reattach listeners
        setTimeout(() => {
            attachCarouselListeners();
        }, 100);
    }

    // Function to fetch and display offers
    function loadOffers() {
        const contentDiv = document.getElementById('mighty-offers-content');
        if (!contentDiv) {
            console.error('Mighty Local: Content div not found');
            return;
        }

        const apiUrl = MightyPublicApi.url('offers', config.shopDomain, null, config.apiBaseUrl);

        fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to load offers: ${response.status} ${response.statusText}`);
                }
                return response.json();
            })
            .then(data => {
                if (data.secondaryColor) {
                    secondaryColor = data.secondaryColor;
                }

                // Ensure we have a valid array
                let offers = [];
                if (Array.isArray(data.offers)) {
                    offers = data.offers;
                } else if (data.offers && typeof data.offers === 'object') {
                    // Handle case where API returns object with numeric keys instead of array
                    offers = Object.values(data.offers);
                } else if (Array.isArray(data)) {
                    offers = data;
                } else if (data && typeof data === 'object') {
                    // Handle case where top-level data is an object
                    offers = Object.values(data);
                }

                if (offers.length === 0) {
                    // Hide the entire widget if no content is available
                    const container = document.getElementById(config.containerId);
                    if (container) {
                        container.style.display = 'none';
                    }
                    return;
                }

                // Sort by sort_order (ascending), then by id as fallback
                const sortedOffers = offers.sort((a, b) => {
                    const orderA = a.sort_order ?? 0;
                    const orderB = b.sort_order ?? 0;
                    if (orderA !== orderB) {
                        return orderA - orderB;
                    }
                    return (a.id || 0) - (b.id || 0);
                });

                // Apply limit only if specified
                allOffers = config.offersLimit !== null && config.offersLimit !== undefined
                    ? sortedOffers.slice(0, config.offersLimit)
                    : sortedOffers;

                // Apply secondary color as CSS variable
                const section = document.querySelector('.mighty-offers-section');
                if (section) {
                    section.style.setProperty('--mighty-btn-color', secondaryColor);
                }

                // Render carousel or static grid
                if (config.carousel) {
                    contentDiv.innerHTML = renderCarousel(allOffers);
                    setTimeout(() => {
                        attachCarouselListeners();
                    }, 100);
                } else {
                    contentDiv.innerHTML = renderGrid(allOffers);
                }
            })
            .catch(error => {
                console.error('Error loading offers:', error);
                // Hide the entire widget on error
                const container = document.getElementById(config.containerId);
                if (container) {
                    container.style.display = 'none';
                }
            });
    }

    // Initialize widget
    function init() {
        // Inject styles
        injectStyles();

        // Find container
        const container = document.getElementById(config.containerId);
        if (!container) {
            console.error('Mighty Local: Container element not found. Please add <div id="mighty-offers-section"></div> to your page.');
            return;
        }

        // Render widget structure
        renderWidget(container);

        // Load offers
        loadOffers();
    }

    // Handle window resize for responsive carousel
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            const currentWidth = window.innerWidth;

            // Only re-render if we've crossed a breakpoint
            const wasDesktop = lastWindowWidth >= 1024;
            const wasTablet = lastWindowWidth >= 768 && lastWindowWidth < 1024;
            const wasMobile = lastWindowWidth < 768;

            const isDesktop = currentWidth >= 1024;
            const isTablet = currentWidth >= 768 && currentWidth < 1024;
            const isMobile = currentWidth < 768;

            // Check if we crossed a breakpoint
            if ((wasDesktop && !isDesktop) || (wasTablet && !isTablet) || (wasMobile && !isMobile)) {
                lastWindowWidth = currentWidth;
                reRenderCarousel();
            }
        }, 250); // Debounce for 250ms
    });


    // Initialize when the page is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    }


    function run_events() {
        setMightyWidgetVariables(document.getElementById((window.MightyEventsConfig || {}).containerId || 'mighty-events-section'), (window.MightyEventsConfig || {}).theme || 'light');
'use strict';

    // Prevent conflicts with existing scripts
    if (window.MightyLocalEventsLoaded) {
        return;
    }
    window.MightyLocalEventsLoaded = true;

    // Configuration - customize these values as needed
    const userConfig = window.MightyEventsConfig || {};
    const config = {
        eventsLimit: userConfig.eventsLimit !== undefined ? userConfig.eventsLimit : null, // null = no limit
        showDate: userConfig.showDate !== false,
        showLocation: userConfig.showLocation !== false,
        shopDomain: userConfig.shopDomain || window.Shopify?.shop || window.location.hostname.replace('www.', ''),
        title: userConfig.title || 'Upcoming Events',
        subtitle: userConfig.subtitle || 'Join us for these exciting upcoming events!',
        containerId: userConfig.containerId || 'mighty-events-section',
        carousel: userConfig.carousel !== false,
        carouselAutoPlay: userConfig.carouselAutoPlay !== false,
        carouselSpeed: userConfig.carouselSpeed || 5000,
        itemsPerSlide: userConfig.itemsPerSlide || 3,
        showViewAllButton: userConfig.showViewAllButton !== false,
        viewAllButtonText: userConfig.viewAllButtonText || 'View All Events',
        viewAllButtonUrl: userConfig.viewAllButtonUrl || '/apps/pages/events',
        apiBaseUrl: userConfig.apiBaseUrl || MightyPublicApi.baseUrl
    };

    // Carousel state
    let currentSlide = 0;
    let totalSlides = 0;
    let allEvents = [];
    let lastWindowWidth = window.innerWidth;
    let primaryColor = '#3b82f6';
    let secondaryColor = '#000000';

    // Get responsive items per slide based on screen size
    function getResponsiveItemsPerSlide() {
        const width = window.innerWidth;
        if (width < 768) {
            return 1; // Mobile: 1 item
        } else if (width >= 768 && width < 1024) {
            return 2; // Tablet: 2 items
        } else {
            return config.itemsPerSlide; // Desktop: user configured (default 3)
        }
    }

    // Inject CSS styles
    function injectStyles() {
        return;
    }

    // Function to decode HTML entities
    function decodeHtmlEntities(text) {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = text;
        return textarea.value;
    }

    // Function to strip HTML tags and decode entities
    function stripHtmlTags(html) {
        if (!html) return '';
        // First decode HTML entities, then strip tags
        const decoded = decodeHtmlEntities(html);
        const div = document.createElement('div');
        div.innerHTML = decoded;
        return div.textContent || div.innerText || '';
    }

    // Function to format date
    function formatDate(dateString) {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
        } catch (e) {
            return dateString;
        }
    }

    // Function to create event card HTML
    function createEventCard(event) {
        // Check per-event hide_dates setting first, then fall back to global config
        const shouldShowDate = !event.hide_dates && config.showDate && (event.start_date_formatted || event.start_date);
        const hasDate = shouldShowDate;
        const locationName = event.location_name || event.location || '';
        const locationAddress = event.location_address || '';
        const hasLocation = config.showLocation && locationName && locationName.trim() !== '';
        const imageUrl = event.image_url || event.image;
        const hasExternalLink = event.link && event.link.trim() !== '';

        // Format date display — prefer next upcoming date from multi-date API
        let eventDateDisplay = '';
        let datesMoreCount = 0;
        if (hasDate) {
            const startDate = event.start_date_formatted || formatDate(event.start_date);
            eventDateDisplay = startDate || '';

            if (event.next_date_time_formatted) {
                eventDateDisplay += ` ${event.next_date_time_formatted}`;
            }

            if (event.dates_count && event.dates_count > 1) {
                datesMoreCount = event.dates_count - 1;
            }
        }

        // Calendar SVG fallback
        const calendarSvg = `
            <div class="mighty-event-image-fallback" style="background-color: ${primaryColor};">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                </svg>
            </div>
        `;

        return `
            <div class="mighty-event-card">
                ${imageUrl ? `<img src="${imageUrl}" alt="${event.title}" class="mighty-event-image">` : calendarSvg}
                <div class="mighty-event-content">
                    ${hasDate && eventDateDisplay ? `<div class="mighty-event-date-badge">${eventDateDisplay}</div>` : ''}
                    ${datesMoreCount > 0 ? `<div style="font-size: 0.8rem; color: #6b7280; margin-bottom: 8px;">+${datesMoreCount} more date${datesMoreCount > 1 ? 's' : ''}</div>` : ''}

                    <h3 class="mighty-event-title">${event.title}</h3>

                    ${hasExternalLink ? `
                        <a href="${event.link}" target="_blank" class="mighty-event-external-link">
                            ${event.link_text || 'Learn more here'}
                            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/>
                            </svg>
                        </a>
                    ` : ''}

                    ${(event.short_description || event.description) ? `<div class="mighty-event-description">${event.short_description || stripHtmlTags(event.description)}</div>` : ''}

                    ${hasLocation ? `
                        <div class="mighty-event-location">
                            <svg class="mighty-event-location-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                            </svg>
                            <span>${locationName}${locationAddress ? `, ${locationAddress}` : ''}</span>
                        </div>
                    ` : ''}

                    <a href="/apps/pages/events/${event.id}" class="mighty-event-button">
                        View Details
                        <svg style="width: 16px; height: 16px; display: inline-block; margin-left: 4px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                        </svg>
                    </a>
                </div>
            </div>
        `;
    }

    // Function to chunk events into slides
    function chunkEvents(events, itemsPerSlide) {
        const chunks = [];
        for (let i = 0; i < events.length; i += itemsPerSlide) {
            chunks.push(events.slice(i, i + itemsPerSlide));
        }
        return chunks;
    }

    // Function to render carousel
    function renderCarousel(events) {
        const itemsPerSlide = getResponsiveItemsPerSlide();

        // For 1-2 items on desktop, don't use carousel
        if (window.innerWidth >= 768 && events.length <= 2) {
            return renderGrid(events);
        }

        const slides = chunkEvents(events, itemsPerSlide);
        totalSlides = slides.length;

        const slidesHtml = slides.map((slideEvents, index) => {
            const eventsHtml = slideEvents.map(createEventCard).join('');
            return `<div class="mighty-events-slide">${eventsHtml}</div>`;
        }).join('');

        const dotsHtml = slides.map((_, index) =>
            `<button class="mighty-events-carousel-dot ${index === 0 ? 'active' : ''}" data-slide="${index}" aria-label="Go to slide ${index + 1}" ${index === 0 ? 'aria-current="true"' : ''}></button>`
        ).join('');

        return `
            <div class="mighty-events-carousel-wrapper">
                ${totalSlides > 1 ? `
                    <button class="mighty-carousel-arrow mighty-events-carousel-arrow-prev" onclick="window.mightyEventsPrev()" style="display: none;" aria-label="Previous slide">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                        </svg>
                    </button>
                    <button class="mighty-carousel-arrow mighty-events-carousel-arrow-next" onclick="window.mightyEventsNext()" aria-label="Next slide">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                        </svg>
                    </button>
                ` : ''}
                <div class="mighty-events-carousel">
                    ${slidesHtml}
                </div>
            </div>
            ${totalSlides > 1 ? `
                <div class="mighty-events-carousel-dots">
                    ${dotsHtml}
                </div>
            ` : ''}
            ${config.showViewAllButton ? `
                <div class="mighty-view-all-container">
                    <a href="${config.viewAllButtonUrl}" class="mighty-view-all-button">
                        ${config.viewAllButtonText}
                    </a>
                </div>
            ` : ''}
        `;
    }

    // Function to render static grid
    function renderGrid(events) {
        const eventsHtml = events.map(createEventCard).join('');
        const itemClass = events.length === 1 ? 'items-1' : events.length === 2 ? 'items-2' : '';
        return `
            <div class="mighty-events-grid ${itemClass}">${eventsHtml}</div>
            ${config.showViewAllButton ? `
                <div class="mighty-view-all-container">
                    <a href="${config.viewAllButtonUrl}" class="mighty-view-all-button">
                        ${config.viewAllButtonText}
                    </a>
                </div>
            ` : ''}
        `;
    }

    // Function to update arrow states
    function updateArrowStates() {
        const prevArrow = document.querySelector('.mighty-events-carousel-arrow-prev');
        const nextArrow = document.querySelector('.mighty-events-carousel-arrow-next');

        if (prevArrow && nextArrow) {
            if (currentSlide === 0) {
                prevArrow.style.display = 'none';
            } else {
                prevArrow.style.display = 'flex';
            }

            if (currentSlide === totalSlides - 1) {
                nextArrow.style.display = 'none';
            } else {
                nextArrow.style.display = 'flex';
            }
        }
    }

    // Function to go to specific slide
    function goToSlide(slideIndex) {
        currentSlide = slideIndex;
        const carousel = document.querySelector('.mighty-events-carousel');
        const dots = document.querySelectorAll('.mighty-events-carousel-dot');

        if (carousel) {
            carousel.style.transform = `translateX(-${currentSlide * 100}%)`;
        }

        // Update dots
        dots.forEach((dot, index) => {
            if (index === currentSlide) {
                dot.classList.add('active');
                dot.setAttribute('aria-current', 'true');
            } else {
                dot.classList.remove('active');
                dot.removeAttribute('aria-current');
            }
        });

        updateArrowStates();
    }

    // Function to go to next slide
    function nextSlide() {
        if (currentSlide < totalSlides - 1) {
            currentSlide++;
            goToSlide(currentSlide);
        }
    }

    // Function to go to previous slide
    function prevSlide() {
        if (currentSlide > 0) {
            currentSlide--;
            goToSlide(currentSlide);
        }
    }

    // Expose functions globally
    window.mightyEventsNext = nextSlide;
    window.mightyEventsPrev = prevSlide;

    // Function to attach carousel event listeners
    function attachCarouselListeners() {
        const dots = document.querySelectorAll('.mighty-events-carousel-dot');
        const carouselWrapper = document.querySelector('.mighty-events-carousel-wrapper');

        // Initialize arrow states on load
        updateArrowStates();

        dots.forEach(dot => {
            dot.addEventListener('click', () => {
                const slideIndex = parseInt(dot.getAttribute('data-slide'));
                goToSlide(slideIndex);
            });
        });

        // Touch/swipe support
        let touchStartX = 0;
        let touchEndX = 0;

        if (carouselWrapper) {
            carouselWrapper.addEventListener('touchstart', (e) => {
                touchStartX = e.changedTouches[0].screenX;
            });

            carouselWrapper.addEventListener('touchend', (e) => {
                touchEndX = e.changedTouches[0].screenX;
                handleSwipe();
            });
        }

        function handleSwipe() {
            if (touchEndX < touchStartX - 50) {
                nextSlide();
            }
            if (touchEndX > touchStartX + 50) {
                prevSlide();
            }
        }

        updateArrowStates();
    }

    // Function to render the widget structure
    function renderWidget(container) {
        container.innerHTML = `
            <div class="mighty-events-section">
                <div class="mighty-events-container">
                    <div class="mighty-events-header">
                        <h2 class="mighty-events-title">${config.title}</h2>
                        <p class="mighty-events-subtitle">${config.subtitle}</p>
                    </div>
                    <div id="mighty-events-content" class="mighty-events-loading">
                        <p>Loading events...</p>
                    </div>
                </div>
            </div>
        `;
    }

    // Function to re-render carousel on resize
    function reRenderCarousel() {
        if (!config.carousel || allEvents.length === 0) {
            return;
        }

        const contentDiv = document.getElementById('mighty-events-content');
        if (!contentDiv) {
            return;
        }

        currentSlide = 0;
        contentDiv.innerHTML = renderCarousel(allEvents);

        setTimeout(() => {
            attachCarouselListeners();
        }, 100);
    }

    // Function to fetch and display events
    function loadEvents() {
        const contentDiv = document.getElementById('mighty-events-content');
        if (!contentDiv) {
            console.error('Mighty Local: Content div not found');
            return;
        }

        const apiUrl = MightyPublicApi.url('events', config.shopDomain, null, config.apiBaseUrl);


        fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to load events: ${response.status} ${response.statusText}`);
                }
                return response.json();
            })
            .then(data => {
                if (data.primaryColor) {
                    primaryColor = data.primaryColor;
                }
                if (data.secondaryColor) {
                    secondaryColor = data.secondaryColor;
                }

                // Ensure we have a valid array
                let events = [];
                if (Array.isArray(data.events)) {
                    events = data.events;
                } else if (data.events && typeof data.events === 'object') {
                    // Handle case where API returns object with numeric keys instead of array
                    events = Object.values(data.events);
                } else if (Array.isArray(data)) {
                    events = data;
                } else if (data && typeof data === 'object') {
                    // Handle case where top-level data is an object
                    events = Object.values(data);
                }

                if (events.length === 0) {
                    // Hide the entire widget if no content is available
                    const container = document.getElementById(config.containerId);
                    if (container) {
                        container.style.display = 'none';
                    }
                    return;
                }

                // Sort by sort_order (ascending), then by id as fallback
                const sortedEvents = events.sort((a, b) => {
                    const orderA = a.sort_order ?? 0;
                    const orderB = b.sort_order ?? 0;
                    if (orderA !== orderB) {
                        return orderA - orderB;
                    }
                    return (a.id || 0) - (b.id || 0);
                });

                // Apply limit only if specified
                allEvents = config.eventsLimit !== null && config.eventsLimit !== undefined
                    ? sortedEvents.slice(0, config.eventsLimit)
                    : sortedEvents;

                // Apply secondary color as CSS variable
                const section = document.querySelector('.mighty-events-section');
                if (section) {
                    section.style.setProperty('--mighty-btn-color', secondaryColor);
                }

                // Render carousel or static grid
                if (config.carousel) {
                    contentDiv.innerHTML = renderCarousel(allEvents);
                    setTimeout(() => {
                        attachCarouselListeners();
                    }, 100);
                } else {
                    contentDiv.innerHTML = renderGrid(allEvents);
                }
            })
            .catch(error => {
                console.error('Error loading events:', error);
                // Hide the entire widget on error
                const container = document.getElementById(config.containerId);
                if (container) {
                    container.style.display = 'none';
                }
            });
    }

    // Initialize widget
    function init() {
        // Inject styles
        injectStyles();

        // Find container
        const container = document.getElementById(config.containerId);
        if (!container) {
            console.error('Mighty Local: Container element not found. Please add <div id="mighty-events-section"></div> to your page.');
            return;
        }

        // Render widget structure
        renderWidget(container);

        // Load events
        loadEvents();
    }

    // Handle window resize for responsive carousel
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            const currentWidth = window.innerWidth;

            // Only re-render if we've crossed a breakpoint
            const wasDesktop = lastWindowWidth >= 1024;
            const wasTablet = lastWindowWidth >= 768 && lastWindowWidth < 1024;
            const wasMobile = lastWindowWidth < 768;

            const isDesktop = currentWidth >= 1024;
            const isTablet = currentWidth >= 768 && currentWidth < 1024;
            const isMobile = currentWidth < 768;

            // Check if we crossed a breakpoint
            if ((wasDesktop && !isDesktop) || (wasTablet && !isTablet) || (wasMobile && !isMobile)) {
                lastWindowWidth = currentWidth;
                reRenderCarousel();
            }
        }, 250); // Debounce for 250ms
    });


    // Initialize when the page is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    }


    function run_announcements() {
        setMightyWidgetVariables(document.getElementById((window.MightyAnnouncementsConfig || {}).containerId || 'mighty-announcements-section'), (window.MightyAnnouncementsConfig || {}).theme || 'light');
'use strict';

    // Prevent conflicts with existing scripts
    if (window.MightyLocalAnnouncementsLoaded) {
        return;
    }
    window.MightyLocalAnnouncementsLoaded = true;

    // Configuration - customize these values as needed
    const userConfig = window.MightyAnnouncementsConfig || {};
    const config = {
        announcementsLimit: userConfig.announcementsLimit !== undefined ? userConfig.announcementsLimit : null, // null = no limit
        showDates: userConfig.showDates === true, // Changed to opt-in instead of opt-out
        shopDomain: userConfig.shopDomain || window.Shopify?.shop || window.location.hostname.replace('www.', ''),
        title: userConfig.title !== undefined ? userConfig.title : 'Announcements', // Default to 'Announcements'
        subtitle: userConfig.subtitle || '',
        containerId: userConfig.containerId || 'mighty-announcements-section',
        carousel: userConfig.carousel !== false,
        carouselAutoPlay: userConfig.carouselAutoPlay !== false,
        carouselSpeed: userConfig.carouselSpeed || 5000,
        itemsPerSlide: userConfig.itemsPerSlide || 1, // Default to 1 for banner style
        showViewAllButton: userConfig.showViewAllButton === true,
        viewAllButtonText: userConfig.viewAllButtonText || 'View All Announcements',
        viewAllButtonUrl: userConfig.viewAllButtonUrl || '/pages/announcements',
        apiBaseUrl: userConfig.apiBaseUrl || MightyPublicApi.baseUrl,
        fullWidth: userConfig.fullWidth !== false, // Default to full-width banner style
        showIcon: userConfig.showIcon === true // Changed to opt-in
    };

    // Carousel state
    let currentSlide = 0;
    let totalSlides = 0;
    let allAnnouncements = [];
    let lastWindowWidth = window.innerWidth;

    // Get responsive items per slide based on screen size
    function getResponsiveItemsPerSlide() {
        // For bulletin board style, always show 1 item
        if (config.fullWidth || config.itemsPerSlide === 1) {
            return 1;
        }

        const width = window.innerWidth;
        if (width < 768) {
            return 1; // Mobile: 1 item
        } else if (width >= 768 && width < 1024) {
            return Math.min(2, config.itemsPerSlide); // Tablet: 2 items max
        } else {
            return config.itemsPerSlide; // Desktop: user configured
        }
    }

    // Inject CSS styles
    function injectStyles() {
        return;
    }

    // Function to decode HTML entities
    function decodeHtmlEntities(text) {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = text;
        return textarea.value;
    }

    // Function to sanitize HTML while preserving formatting
    function sanitizeHtml(html) {
        if (!html) return '';

        // Decode HTML entities first
        const decoded = decodeHtmlEntities(html);

        // Create a temporary div to parse the HTML
        const div = document.createElement('div');
        div.innerHTML = decoded;

        // Return the HTML content (preserving formatting tags)
        return div.innerHTML;
    }

    // Function to format date
    function formatDate(dateString) {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
        } catch (e) {
            return dateString;
        }
    }

    // Function to create announcement card HTML
    function createAnnouncementCard(announcement, isBulletinStyle) {
        const hasShowFrom = config.showDates && announcement.show_from_formatted;
        const hasShowUntil = config.showDates && announcement.show_until_formatted;
        const cardStyle = isBulletinStyle ? 'bulletin-style' : 'card-style';

        return `
            <div class="mighty-announcement-card ${cardStyle}">
                <div class="mighty-announcement-content">
                    ${config.showIcon ? `
                        <div class="mighty-announcement-icon">
                            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"/>
                            </svg>
                        </div>
                    ` : ''}

                    <div class="mighty-announcement-text-content">
                        ${(hasShowFrom || hasShowUntil) ? `
                            <div class="mighty-announcement-dates">
                                ${hasShowFrom ? `<span class="mighty-announcement-date-badge">From: ${announcement.show_from_formatted}</span>` : ''}
                                ${hasShowUntil ? `<span class="mighty-announcement-date-badge">Until: ${announcement.show_until_formatted}</span>` : ''}
                            </div>
                        ` : ''}

                        ${announcement.message ? `<div class="mighty-announcement-message">${sanitizeHtml(announcement.message)}</div>` : ''}
                    </div>

                </div>
            </div>
        `;
    }

    // Function to chunk announcements into slides
    function chunkAnnouncements(announcements, itemsPerSlide) {
        const chunks = [];
        for (let i = 0; i < announcements.length; i += itemsPerSlide) {
            chunks.push(announcements.slice(i, i + itemsPerSlide));
        }
        return chunks;
    }

    // Function to render carousel
    function renderCarousel(announcements) {
        const itemsPerSlide = getResponsiveItemsPerSlide();
        const isBulletinStyle = itemsPerSlide === 1;

        // For 1-2 items on desktop, don't use carousel for multi-item layouts
        if (!isBulletinStyle && window.innerWidth >= 768 && announcements.length <= 2) {
            return renderGrid(announcements);
        }

        const slides = chunkAnnouncements(announcements, itemsPerSlide);
        totalSlides = slides.length;

        const slidesHtml = slides.map((slideAnnouncements, index) => {
            const announcementsHtml = slideAnnouncements.map(ann => createAnnouncementCard(ann, isBulletinStyle)).join('');
            const slideClass = isBulletinStyle ? 'mighty-announcements-slide' : 'mighty-announcements-slide multi-item';
            return `<div class="${slideClass}">${announcementsHtml}</div>`;
        }).join('');

        const dotsHtml = slides.map((_, index) =>
            `<button class="mighty-announcements-carousel-dot ${index === 0 ? 'active' : ''}" data-slide="${index}"></button>`
        ).join('');

        return `
            <div class="mighty-announcements-carousel-wrapper">
                <div class="mighty-announcements-carousel">
                    ${slidesHtml}
                </div>
            </div>
            ${totalSlides > 1 ? `
                <div class="mighty-announcements-carousel-dots">
                    ${dotsHtml}
                </div>
            ` : ''}
            ${config.showViewAllButton ? `
                <div class="mighty-view-all-container">
                    <a href="${config.viewAllButtonUrl}" class="mighty-view-all-button">
                        ${config.viewAllButtonText}
                    </a>
                </div>
            ` : ''}
        `;
    }

    // Function to render static grid
    function renderGrid(announcements) {
        const itemsPerSlide = getResponsiveItemsPerSlide();
        const isBulletinStyle = itemsPerSlide === 1;
        const announcementsHtml = announcements.map(ann => createAnnouncementCard(ann, isBulletinStyle)).join('');
        const gridClass = isBulletinStyle ? 'mighty-announcements-grid' : 'mighty-announcements-grid multi-item';
        const itemClass = !isBulletinStyle && announcements.length === 2 ? 'items-2' : '';

        return `
            <div class="${gridClass} ${itemClass}">${announcementsHtml}</div>
            ${config.showViewAllButton ? `
                <div class="mighty-view-all-container">
                    <a href="${config.viewAllButtonUrl}" class="mighty-view-all-button">
                        ${config.viewAllButtonText}
                    </a>
                </div>
            ` : ''}
        `;
    }

    // Function to update arrow states (removed - no arrows in announcements widget)
    function updateArrowStates() {
        // No arrows to update
    }

    // Function to go to specific slide
    function goToSlide(slideIndex) {
        currentSlide = slideIndex;
        const carousel = document.querySelector('.mighty-announcements-carousel');
        const dots = document.querySelectorAll('.mighty-announcements-carousel-dot');

        if (carousel) {
            carousel.style.transform = `translateX(-${currentSlide * 100}%)`;
        }

        // Update dots
        dots.forEach((dot, index) => {
            if (index === currentSlide) {
                dot.classList.add('active');
            } else {
                dot.classList.remove('active');
            }
        });
    }

    // Function to go to next slide
    function nextSlide() {
        if (currentSlide < totalSlides - 1) {
            currentSlide++;
            goToSlide(currentSlide);
        }
    }

    // Function to go to previous slide
    function prevSlide() {
        if (currentSlide > 0) {
            currentSlide--;
            goToSlide(currentSlide);
        }
    }

    // Expose functions globally
    window.mightyAnnouncementsNext = nextSlide;
    window.mightyAnnouncementsPrev = prevSlide;

    // Function to attach carousel event listeners
    function attachCarouselListeners() {
        const dots = document.querySelectorAll('.mighty-announcements-carousel-dot');
        const carouselWrapper = document.querySelector('.mighty-announcements-carousel-wrapper');

        dots.forEach(dot => {
            dot.addEventListener('click', () => {
                const slideIndex = parseInt(dot.getAttribute('data-slide'));
                goToSlide(slideIndex);
            });
        });

        // Touch/swipe support
        let touchStartX = 0;
        let touchEndX = 0;

        if (carouselWrapper) {
            carouselWrapper.addEventListener('touchstart', (e) => {
                touchStartX = e.changedTouches[0].screenX;
            });

            carouselWrapper.addEventListener('touchend', (e) => {
                touchEndX = e.changedTouches[0].screenX;
                handleSwipe();
            });
        }

        function handleSwipe() {
            if (touchEndX < touchStartX - 50) {
                nextSlide();
            }
            if (touchEndX > touchStartX + 50) {
                prevSlide();
            }
        }
    }

    // Function to render the widget structure
    function renderWidget(container) {
        const hasHeader = config.title || config.subtitle;
        const containerClass = hasHeader ? 'mighty-announcements-container has-header' : 'mighty-announcements-container';

        container.innerHTML = `
            <div class="mighty-announcements-section">
                <div class="${containerClass}">
                    ${hasHeader ? `
                        <div class="mighty-announcements-header">
                            ${config.title ? `<h2 class="mighty-announcements-title">${config.title}</h2>` : ''}
                            ${config.subtitle ? `<p class="mighty-announcements-subtitle">${config.subtitle}</p>` : ''}
                        </div>
                    ` : ''}
                    <div id="mighty-announcements-content" class="mighty-announcements-loading">
                        <p>Loading announcements...</p>
                    </div>
                </div>
            </div>
        `;
    }

    // Function to re-render carousel on resize
    function reRenderCarousel() {
        if (!config.carousel || allAnnouncements.length === 0) {
            return;
        }

        const contentDiv = document.getElementById('mighty-announcements-content');
        if (!contentDiv) {
            return;
        }

        currentSlide = 0;
        contentDiv.innerHTML = renderCarousel(allAnnouncements);

        setTimeout(() => {
            attachCarouselListeners();
        }, 100);
    }

    // Function to fetch and display announcements
    function loadAnnouncements() {
        const contentDiv = document.getElementById('mighty-announcements-content');
        if (!contentDiv) {
            console.error('Mighty Local: Content div not found');
            return;
        }

        const apiUrl = MightyPublicApi.url('announcements', config.shopDomain, null, config.apiBaseUrl);

        console.log('Mighty Announcements Widget: Fetching from', apiUrl);

        fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to load announcements: ${response.status} ${response.statusText}`);
                }
                return response.json();
            })
            .then(data => {
                // Ensure we have a valid array
                let announcements = [];
                if (Array.isArray(data.announcements)) {
                    announcements = data.announcements;
                } else if (data.announcements && typeof data.announcements === 'object') {
                    // Handle case where API returns object with numeric keys instead of array
                    announcements = Object.values(data.announcements);
                } else if (Array.isArray(data)) {
                    announcements = data;
                } else if (data && typeof data === 'object') {
                    // Handle case where top-level data is an object
                    announcements = Object.values(data);
                }

                if (announcements.length === 0) {
                    // Hide the entire widget if no content is available
                    const container = document.getElementById(config.containerId);
                    if (container) {
                        container.style.display = 'none';
                    }
                    return;
                }

                // Sort by sort_order (ascending), then by id as fallback
                const sortedAnnouncements = announcements.sort((a, b) => {
                    const orderA = a.sort_order ?? 0;
                    const orderB = b.sort_order ?? 0;
                    if (orderA !== orderB) {
                        return orderA - orderB;
                    }
                    return (a.id || 0) - (b.id || 0);
                });

                // Apply limit only if specified
                allAnnouncements = config.announcementsLimit !== null && config.announcementsLimit !== undefined
                    ? sortedAnnouncements.slice(0, config.announcementsLimit)
                    : sortedAnnouncements;

                // Render carousel or static grid
                if (config.carousel) {
                    contentDiv.innerHTML = renderCarousel(allAnnouncements);
                    setTimeout(() => {
                        attachCarouselListeners();
                    }, 100);
                } else {
                    contentDiv.innerHTML = renderGrid(allAnnouncements);
                }
            })
            .catch(error => {
                console.error('Error loading announcements:', error);
                // Hide the entire widget on error
                const container = document.getElementById(config.containerId);
                if (container) {
                    container.style.display = 'none';
                }
            });
    }

    // Initialize widget
    function init() {
        // Inject styles
        injectStyles();

        // Find container
        const container = document.getElementById(config.containerId);
        if (!container) {
            console.error('Mighty Local: Container element not found. Please add <div id="mighty-announcements-section"></div> to your page.');
            return;
        }

        // Render widget structure
        renderWidget(container);

        // Load announcements
        loadAnnouncements();
    }

    // Handle window resize for responsive carousel
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            const currentWidth = window.innerWidth;

            // Only re-render if we've crossed a breakpoint
            const wasDesktop = lastWindowWidth >= 1024;
            const wasTablet = lastWindowWidth >= 768 && lastWindowWidth < 1024;
            const wasMobile = lastWindowWidth < 768;

            const isDesktop = currentWidth >= 1024;
            const isTablet = currentWidth >= 768 && currentWidth < 1024;
            const isMobile = currentWidth < 768;

            // Check if we crossed a breakpoint
            if ((wasDesktop && !isDesktop) || (wasTablet && !isTablet) || (wasMobile && !isMobile)) {
                lastWindowWidth = currentWidth;
                reRenderCarousel();
            }
        }, 250); // Debounce for 250ms
    });


    // Initialize when the page is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    }


    function run_featured() {
        setMightyWidgetVariables(document.getElementById((window.MightyFeaturedConfig || {}).containerId || 'mighty-featured-section'), (window.MightyFeaturedConfig || {}).theme || 'light');
'use strict';

    if (window.MightyLocalFeaturedLoaded) {
        return;
    }
    window.MightyLocalFeaturedLoaded = true;

    const userConfig = window.MightyFeaturedConfig || {};
    const config = {
        featuredLimit: userConfig.featuredLimit || 6,
        shopDomain: userConfig.shopDomain || window.Shopify?.shop || window.location.hostname.replace('www.', ''),
        title: userConfig.title || 'Featured Promotions',
        subtitle: userConfig.subtitle || 'Check out what we\'re featuring this month!',
        containerId: userConfig.containerId || 'mighty-featured-section',
        carousel: userConfig.carousel !== false,
        carouselAutoPlay: userConfig.carouselAutoPlay !== false,
        carouselSpeed: userConfig.carouselSpeed || 5000,
        itemsPerSlide: userConfig.itemsPerSlide || 3,
        showViewAllButton: userConfig.showViewAllButton !== false,
        viewAllButtonText: userConfig.viewAllButtonText || 'View All Featured',
        viewAllButtonUrl: userConfig.viewAllButtonUrl || '/apps/pages/featured',
        apiBaseUrl: userConfig.apiBaseUrl || MightyPublicApi.baseUrl
    };

    let currentSlide = 0;
    let totalSlides = 0;
    let allFeatured = [];
    let lastWindowWidth = window.innerWidth;
    let autoPlayInterval = null;
    let secondaryColor = '#000000';
    let prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', (e) => {
        prefersReducedMotion = e.matches;
        if (prefersReducedMotion) {
            stopAutoPlay();
        }
    });

    function getResponsiveItemsPerSlide() {
        const width = window.innerWidth;
        if (width < 768) {
            return 1;
        } else if (width >= 768 && width < 1024) {
            return 2;
        } else {
            return config.itemsPerSlide;
        }
    }

    function escapeAttr(str) {
        if (!str) return '';
        return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function injectStyles() {
        return;
    }

    function decodeHtmlEntities(text) {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = text;
        return textarea.value;
    }

    function stripHtmlTags(html) {
        if (!html) return '';
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || '';
    }

    function createCollageHtml(imageUrls, title) {
        const escaped = escapeAttr(title);
        const count = imageUrls.length;

        if (count >= 4) {
            const extra = count > 4 ? `<div class="mighty-collage-more" aria-hidden="true">+${count - 4}</div>` : '';
            return `<div class="mighty-featured-collage mighty-collage-4" role="img" aria-label="${escaped} — ${count} images">
                <img src="${escapeAttr(imageUrls[0])}" alt="${escaped}" loading="lazy">
                <img src="${escapeAttr(imageUrls[1])}" alt="" aria-hidden="true" loading="lazy">
                <img src="${escapeAttr(imageUrls[2])}" alt="" aria-hidden="true" loading="lazy">
                <div class="mighty-collage-overlay"><img src="${escapeAttr(imageUrls[3])}" alt="" aria-hidden="true" loading="lazy">${extra}</div>
            </div>`;
        }
        if (count === 3) {
            return `<div class="mighty-featured-collage mighty-collage-3" role="img" aria-label="${escaped} — 3 images">
                <img class="mighty-collage-hero" src="${escapeAttr(imageUrls[0])}" alt="${escaped}" loading="lazy">
                <img src="${escapeAttr(imageUrls[1])}" alt="" aria-hidden="true" loading="lazy">
                <img src="${escapeAttr(imageUrls[2])}" alt="" aria-hidden="true" loading="lazy">
            </div>`;
        }
        if (count === 2) {
            return `<div class="mighty-featured-collage mighty-collage-2" role="img" aria-label="${escaped} — 2 images">
                <img src="${escapeAttr(imageUrls[0])}" alt="${escaped}" loading="lazy">
                <img src="${escapeAttr(imageUrls[1])}" alt="" aria-hidden="true" loading="lazy">
            </div>`;
        }
        return '';
    }

    function createFeaturedCard(featured) {
        const imageUrl = featured.image_url || featured.image;
        const imageUrls = featured.image_urls || [];
        const title = decodeHtmlEntities(featured.title || '');
        const description = featured.short_description || (featured.description ? stripHtmlTags(featured.description) : '');

        let imageHtml = '';
        if (imageUrls.length >= 2) {
            imageHtml = createCollageHtml(imageUrls, title);
        } else if (imageUrl) {
            imageHtml = `<img src="${escapeAttr(imageUrl)}" alt="${escapeAttr(title)}" class="mighty-featured-image" loading="lazy">`;
        }

        return `
            <article class="mighty-featured-card">
                ${imageHtml}
                <div class="mighty-featured-content">
                    <h3 class="mighty-featured-title-card">${title}</h3>
                    ${description ? `<p class="mighty-featured-description">${description}</p>` : ''}

                    <a href="/apps/pages/featured/${featured.id}" class="mighty-featured-button">
                        Learn More<span class="mighty-sr-only"> about ${escapeAttr(title)}</span>
                    </a>
                </div>
            </article>
        `;
    }

    function chunkFeatured(featured, itemsPerSlide) {
        const chunks = [];
        for (let i = 0; i < featured.length; i += itemsPerSlide) {
            chunks.push(featured.slice(i, i + itemsPerSlide));
        }
        return chunks;
    }

    function renderCarousel(featured) {
        const itemsPerSlide = getResponsiveItemsPerSlide();

        if (window.innerWidth >= 768 && featured.length <= 2) {
            return renderGrid(featured);
        }

        const slides = chunkFeatured(featured, itemsPerSlide);
        totalSlides = slides.length;

        const slidesHtml = slides.map((slideFeatured, index) => {
            const featuredHtml = slideFeatured.map(createFeaturedCard).join('');
            return `<div class="mighty-featured-slide" role="group" aria-roledescription="slide" aria-label="Slide ${index + 1} of ${slides.length}">${featuredHtml}</div>`;
        }).join('');

        const dotsHtml = slides.map((_, index) =>
            `<button class="mighty-carousel-dot ${index === 0 ? 'active' : ''}" data-slide="${index}" aria-label="Go to slide ${index + 1}" ${index === 0 ? 'aria-current="true"' : ''}></button>`
        ).join('');

        return `
            <div class="mighty-featured-carousel-wrapper" role="region" aria-roledescription="carousel" aria-label="${escapeAttr(config.title)}">
                ${totalSlides > 1 ? `
                    <button class="mighty-carousel-arrow mighty-featured-carousel-arrow-prev" aria-label="Previous slide" style="display: none;">
                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                        </svg>
                    </button>
                    <button class="mighty-carousel-arrow mighty-featured-carousel-arrow-next" aria-label="Next slide">
                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                        </svg>
                    </button>
                ` : ''}
                <div class="mighty-featured-carousel" aria-live="polite">
                    ${slidesHtml}
                </div>
            </div>
            ${totalSlides > 1 ? `
                <div class="mighty-carousel-dots" role="tablist" aria-label="Slide controls">
                    ${dotsHtml}
                </div>
            ` : ''}
            ${config.showViewAllButton ? `
                <div class="mighty-view-all-container">
                    <a href="${config.viewAllButtonUrl}" class="mighty-view-all-button">
                        ${config.viewAllButtonText}
                    </a>
                </div>
            ` : ''}
        `;
    }

    function renderGrid(featured) {
        const featuredHtml = featured.map(createFeaturedCard).join('');
        const itemClass = featured.length === 1 ? 'items-1' : featured.length === 2 ? 'items-2' : '';
        return `
            <div class="mighty-featured-grid ${itemClass}">${featuredHtml}</div>
            ${config.showViewAllButton ? `
                <div class="mighty-view-all-container">
                    <a href="${config.viewAllButtonUrl}" class="mighty-view-all-button">
                        ${config.viewAllButtonText}
                    </a>
                </div>
            ` : ''}
        `;
    }

    function updateArrowStates() {
        const prevArrow = document.querySelector('.mighty-featured-carousel-arrow-prev');
        const nextArrow = document.querySelector('.mighty-featured-carousel-arrow-next');

        if (prevArrow && nextArrow) {
            prevArrow.style.display = currentSlide === 0 ? 'none' : 'flex';
            nextArrow.style.display = currentSlide === totalSlides - 1 ? 'none' : 'flex';
        }
    }

    function goToSlide(slideIndex) {
        currentSlide = slideIndex;
        const carousel = document.querySelector('.mighty-featured-carousel');
        const dots = document.querySelectorAll('.mighty-carousel-dot');

        if (carousel) {
            carousel.style.transform = `translateX(-${currentSlide * 100}%)`;
        }

        dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === currentSlide);
            if (index === currentSlide) {
                dot.setAttribute('aria-current', 'true');
            } else {
                dot.removeAttribute('aria-current');
            }
        });

        updateArrowStates();
    }

    function nextSlide() {
        if (currentSlide < totalSlides - 1) {
            goToSlide(currentSlide + 1);
        }
    }

    function prevSlide() {
        if (currentSlide > 0) {
            goToSlide(currentSlide - 1);
        }
    }

    function startAutoPlay() {
        if (!config.carouselAutoPlay || prefersReducedMotion || totalSlides <= 1) return;
        stopAutoPlay();
        autoPlayInterval = setInterval(() => {
            if (currentSlide < totalSlides - 1) {
                goToSlide(currentSlide + 1);
            } else {
                goToSlide(0);
            }
        }, config.carouselSpeed);
    }

    function stopAutoPlay() {
        if (autoPlayInterval) {
            clearInterval(autoPlayInterval);
            autoPlayInterval = null;
        }
    }

    window.mightyFeaturedNext = nextSlide;
    window.mightyFeaturedPrev = prevSlide;

    function attachCarouselListeners() {
        const dots = document.querySelectorAll('.mighty-carousel-dot');
        const carouselWrapper = document.querySelector('.mighty-featured-carousel-wrapper');
        const prevBtn = document.querySelector('.mighty-featured-carousel-arrow-prev');
        const nextBtn = document.querySelector('.mighty-featured-carousel-arrow-next');

        updateArrowStates();

        dots.forEach(dot => {
            dot.addEventListener('click', () => {
                goToSlide(parseInt(dot.getAttribute('data-slide')));
                stopAutoPlay();
            });
        });

        if (prevBtn) {
            prevBtn.addEventListener('click', () => { prevSlide(); stopAutoPlay(); });
        }
        if (nextBtn) {
            nextBtn.addEventListener('click', () => { nextSlide(); stopAutoPlay(); });
        }

        // Keyboard navigation
        if (carouselWrapper) {
            carouselWrapper.addEventListener('keydown', (e) => {
                if (e.key === 'ArrowLeft') {
                    e.preventDefault();
                    prevSlide();
                    stopAutoPlay();
                } else if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    nextSlide();
                    stopAutoPlay();
                }
            });

            // Pause auto-play on hover/focus
            carouselWrapper.addEventListener('mouseenter', stopAutoPlay);
            carouselWrapper.addEventListener('focusin', stopAutoPlay);
            carouselWrapper.addEventListener('mouseleave', startAutoPlay);
            carouselWrapper.addEventListener('focusout', (e) => {
                if (!carouselWrapper.contains(e.relatedTarget)) {
                    startAutoPlay();
                }
            });

            // Touch/swipe support
            let touchStartX = 0;
            carouselWrapper.addEventListener('touchstart', (e) => {
                touchStartX = e.changedTouches[0].screenX;
                stopAutoPlay();
            }, { passive: true });

            carouselWrapper.addEventListener('touchend', (e) => {
                const touchEndX = e.changedTouches[0].screenX;
                const diff = touchEndX - touchStartX;
                if (diff < -50) nextSlide();
                if (diff > 50) prevSlide();
            }, { passive: true });
        }

        startAutoPlay();
    }

    function renderWidget(container) {

        container.innerHTML = `
            <section class="mighty-featured-section" aria-label="${escapeAttr(config.title)}">
                <div class="mighty-featured-container">
                    <div class="mighty-featured-header">
                        <h2 class="mighty-featured-title">${config.title}</h2>
                        <p class="mighty-featured-subtitle">${config.subtitle}</p>
                    </div>
                    <div id="mighty-featured-content" class="mighty-featured-loading" role="status" aria-live="polite">
                        <p>Loading featured promotions...</p>
                    </div>
                </div>
            </section>
        `;
    }

    function reRenderCarousel() {
        if (!config.carousel || allFeatured.length === 0) return;

        const contentDiv = document.getElementById('mighty-featured-content');
        if (!contentDiv) return;

        currentSlide = 0;
        stopAutoPlay();
        contentDiv.innerHTML = renderCarousel(allFeatured);

        setTimeout(() => {
            attachCarouselListeners();
        }, 100);
    }

    function loadFeatured() {
        const contentDiv = document.getElementById('mighty-featured-content');
        if (!contentDiv) {
            console.error('Mighty Local: Content div not found');
            return;
        }

        const apiUrl = MightyPublicApi.url('featured', config.shopDomain, null, config.apiBaseUrl);

        fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to load featured promotions: ${response.status} ${response.statusText}`);
                }
                return response.json();
            })
            .then(data => {
                if (data.secondaryColor) {
                    secondaryColor = data.secondaryColor;
                }

                const featured = data.featured || data || [];

                if (featured.length === 0) {
                    const container = document.getElementById(config.containerId);
                    if (container) {
                        container.style.display = 'none';
                    }
                    return;
                }

                const sortedFeatured = featured.sort((a, b) => {
                    const orderA = a.sort_order ?? 0;
                    const orderB = b.sort_order ?? 0;
                    if (orderA !== orderB) return orderA - orderB;
                    return (a.id || 0) - (b.id || 0);
                });

                allFeatured = sortedFeatured.slice(0, config.featuredLimit);

                contentDiv.removeAttribute('role');

                const section = document.querySelector('.mighty-featured-section');
                if (section) {
                    section.style.setProperty('--mighty-btn-color', secondaryColor);
                }

                if (config.carousel) {
                    contentDiv.innerHTML = renderCarousel(allFeatured);
                    setTimeout(() => {
                        attachCarouselListeners();
                    }, 100);
                } else {
                    contentDiv.innerHTML = renderGrid(allFeatured);
                }
            })
            .catch(error => {
                console.error('Error loading featured promotions:', error);
                const container = document.getElementById(config.containerId);
                if (container) {
                    container.style.display = 'none';
                }
            });
    }

    function init() {
        injectStyles();

        const container = document.getElementById(config.containerId);
        if (!container) {
            console.error('Mighty Local: Container element not found. Please add <div id="mighty-featured-section"></div> to your page.');
            return;
        }

        renderWidget(container);
        loadFeatured();
    }

    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            const currentWidth = window.innerWidth;
            const wasDesktop = lastWindowWidth >= 1024;
            const wasTablet = lastWindowWidth >= 768 && lastWindowWidth < 1024;
            const wasMobile = lastWindowWidth < 768;
            const isDesktop = currentWidth >= 1024;
            const isTablet = currentWidth >= 768 && currentWidth < 1024;
            const isMobile = currentWidth < 768;

            if ((wasDesktop && !isDesktop) || (wasTablet && !isTablet) || (wasMobile && !isMobile)) {
                lastWindowWidth = currentWidth;
                reRenderCarousel();
            }
        }, 250);
    });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    }


    function run_campaign() {
        setMightyWidgetVariables(document.getElementById((window.MightyCampaignConfig || {}).containerId || 'mighty-campaign-section'), (window.MightyCampaignConfig || {}).theme || 'light');
if (window.MightyLocalCampaignLoaded) return;
    window.MightyLocalCampaignLoaded = true;

    var config = window.MightyCampaignConfig || {};
    var campaignId = config.campaignId || null;
    var shopDomain = config.shopDomain || (typeof Shopify !== 'undefined' && Shopify.shop ? Shopify.shop : window.location.hostname);
    var containerId = config.containerId || 'mighty-campaign-section';
    var ctaText = config.ctaText || null;
    var detailBaseUrl = config.detailBaseUrl || '/apps/pages/campaign';

    var container = document.getElementById(containerId);
    if (!container) return;

    var url = MightyPublicApi.url('campaign', shopDomain, { campaign_id: campaignId }, config.apiBaseUrl);

    fetch(url)
        .then(function(response) { return response.json(); })
        .then(function(data) {
            if (!data.success || !data.campaign) {
                container.style.display = 'none';
                return;
            }

            var campaign = data.campaign;
            var btnColor = data.secondaryColor || '#000000';
            var bannerUrl = campaign.banner_url;
            var detailUrl = detailBaseUrl + '/' + campaign.id + '/' + (campaign.slug || '');
            var buttonLabel = ctaText || campaign.link_text || 'Learn More';
            var showOverlay = campaign.banner_show_overlay;

            injectStyles(btnColor, showOverlay);

            if (showOverlay) {
                container.innerHTML = createOverlayHtml(campaign, bannerUrl, detailUrl, buttonLabel);
            } else {
                container.innerHTML = createImageHtml(campaign, bannerUrl, detailUrl);
            }
        })
        .catch(function() {
            container.style.display = 'none';
        });

    function injectStyles(btnColor, showOverlay) {
        container.style.setProperty('--mighty-secondary-color', btnColor || '#000000');
    }

    function createOverlayHtml(campaign, bannerUrl, detailUrl, buttonLabel) {
        var bgClass = bannerUrl ? ' mighty-campaign-banner--overlay' : ' mighty-campaign-banner--overlay mighty-campaign-no-image';
        var altText = escapeAttr(campaign.banner_alt_text || campaign.title);

        var html = '<a href="' + detailUrl + '" class="mighty-campaign-banner' + bgClass + '">';

        if (bannerUrl) {
            html += '<img src="' + bannerUrl + '" alt="' + altText + '" />';
        }

        html += '<div class="mighty-campaign-banner-gradient"></div>';
        html += '<div class="mighty-campaign-banner-content">';
        html += '<h2 class="mighty-campaign-banner-title">' + escapeHtml(campaign.title) + '</h2>';

        if (campaign.subtitle) {
            html += '<p class="mighty-campaign-banner-subtitle">' + escapeHtml(campaign.subtitle) + '</p>';
        } else if (campaign.short_description) {
            html += '<p class="mighty-campaign-banner-subtitle">' + escapeHtml(campaign.short_description) + '</p>';
        } else if (campaign.description) {
            var desc = campaign.description.length > 120 ? campaign.description.substring(0, 120) + '...' : campaign.description;
            html += '<p class="mighty-campaign-banner-subtitle">' + escapeHtml(desc) + '</p>';
        }

        html += '<span class="mighty-campaign-banner-btn">' + escapeHtml(buttonLabel) + '</span>';
        html += '</div>';
        html += '</a>';

        return html;
    }

    function createImageHtml(campaign, bannerUrl, detailUrl) {
        if (!bannerUrl) return '';

        var altText = escapeAttr(campaign.banner_alt_text || campaign.title);
        var img = '<img src="' + bannerUrl + '" alt="' + altText + '" />';

        return '<a href="' + detailUrl + '" class="mighty-campaign-banner">' + img + '</a>';
    }

    function escapeHtml(text) {
        if (!text) return '';
        var div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    function escapeAttr(text) {
        if (!text) return '';
        return text.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    }


    function run_locationSelector() {
        setMightyWidgetVariables(document.getElementById('mighty-location-selector'), (window.MightyLocationSelectorConfig || {}).theme || 'light');
        setMightyWidgetVariables(document.getElementById('mighty-location-selector-mobile'), (window.MightyLocationSelectorConfig || {}).theme || 'light');
'use strict';

    // Prevent conflicts with existing scripts
    if (window.MightyLocalLocationSelectorLoaded) {
        return;
    }
    window.MightyLocalLocationSelectorLoaded = true;

    // Configuration
    const userConfig = window.MightyLocationSelectorConfig || {};
    const config = {
        shopDomain: userConfig.shopDomain || window.Shopify?.shop || window.location.hostname.replace('www.', ''),
        defaultLocationId: userConfig.defaultLocationId || null,
        showHours: userConfig.showHours !== false,
        showCityState: userConfig.showCityState !== false,
        showPhone: userConfig.showPhone !== false,
        theme: userConfig.theme || 'light',
        apiBaseUrl: userConfig.apiBaseUrl || null // Allow custom API URL
    };

    let locations = [];
    let selectedLocation = null;
    let hasDesktopContainer = false;
    let hasMobileContainer = false;

    // Determine API base URL
    function getApiBaseUrl() {
        if (config.apiBaseUrl) {
            return config.apiBaseUrl;
        }

        return MightyPublicApi.baseUrl;
    }

    // Inject CSS styles
    function injectStyles() {
        return;
    }

    function getCurrentDayAndTime(timezone) {
        const now = new Date();

        if (timezone) {
            const parts = new Intl.DateTimeFormat('en-US', {
                timeZone: timezone,
                weekday: 'long',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            }).formatToParts(now);

            const values = parts.reduce((result, part) => {
                if (part.type !== 'literal') {
                    result[part.type] = part.value;
                }
                return result;
            }, {});

            const day = (values.weekday || '').toLowerCase();
            const hours = parseInt(values.hour || '0', 10);
            const minutes = parseInt(values.minute || '0', 10);

            return {
                day,
                currentTime: hours * 60 + minutes,
                hours,
                minutes
            };
        }

        const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        const day = days[now.getDay()];
        const hours = now.getHours();
        const minutes = now.getMinutes();
        return { day, currentTime: hours * 60 + minutes, hours, minutes };
    }

    // Parse time string to minutes (handles both 12-hour "9:00 AM" and 24-hour "09:00" formats)
    function parseTimeToMinutes(timeStr) {
        if (!timeStr) return null;

        // Try 12-hour format first (e.g., "9:00 AM" or "5:00 PM")
        const match12h = timeStr.match(/(\d+):(\d+)\s*(am|pm)/i);
        if (match12h) {
            let hours = parseInt(match12h[1]);
            const minutes = parseInt(match12h[2]);
            const period = match12h[3].toLowerCase();

            if (period === 'pm' && hours !== 12) hours += 12;
            if (period === 'am' && hours === 12) hours = 0;

            return hours * 60 + minutes;
        }

        // Try 24-hour format (e.g., "09:00" or "17:00")
        const match24h = timeStr.match(/^(\d+):(\d+)$/);
        if (match24h) {
            const hours = parseInt(match24h[1]);
            const minutes = parseInt(match24h[2]);
            return hours * 60 + minutes;
        }

        return null;
    }

    function getTodayDateString(timezone) {
        const now = new Date();

        if (timezone) {
            const parts = new Intl.DateTimeFormat('en-US', {
                timeZone: timezone,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            }).formatToParts(now);

            const values = parts.reduce((result, part) => {
                if (part.type !== 'literal') {
                    result[part.type] = part.value;
                }
                return result;
            }, {});

            return `${values.year}-${values.month}-${values.day}`;
        }

        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    function buildLocationStatus(isOpen, opensAt, closesAt) {
        if (isOpen && closesAt) {
            return {
                isOpen: true,
                opensAt: null,
                closesAt,
                displayText: `Open until ${closesAt}`
            };
        }

        if (!isOpen && opensAt) {
            return {
                isOpen: false,
                opensAt,
                closesAt: null,
                displayText: `Opens at ${opensAt}`
            };
        }

        return {
            isOpen: false,
            opensAt: null,
            closesAt: null,
            displayText: 'Closed'
        };
    }

    function getLocationTodayContext(location) {
        const timezone = location && location.timezone ? location.timezone : null;
        const fallbackDay = getCurrentDayAndTime(timezone).day;
        const fallbackDayName = fallbackDay.charAt(0).toUpperCase() + fallbackDay.slice(1);

        return {
            todayName: location && location.today_name ? location.today_name : fallbackDayName,
            todayKey: location && location.today_name ? location.today_name.toLowerCase() : fallbackDay,
            todayDate: location && location.today_date ? location.today_date : getTodayDateString(timezone)
        };
    }

    function getLocationHoursStatus(location) {
        if (!location) {
            return buildLocationStatus(false, null, null);
        }

        if (location.hours_status) {
            return {
                isOpen: Boolean(location.hours_status.is_open_now),
                opensAt: location.hours_status.opens_at || null,
                closesAt: location.hours_status.closes_at || null,
                displayText: location.hours_status.display_text || 'Closed'
            };
        }

        const { todayKey, todayDate } = getLocationTodayContext(location);
        const timezone = location.timezone || null;
        const todaySpecialHours = location.today_special_hours
            || (location.special_hours && location.special_hours[todayDate] ? location.special_hours[todayDate] : null);

        if (todaySpecialHours) {
            if (todaySpecialHours.is_closed || todaySpecialHours.status === 'closed') {
                return buildLocationStatus(false, null, null);
            }

            if (todaySpecialHours.open && todaySpecialHours.close) {
                const { currentTime } = getCurrentDayAndTime(timezone);
                const openTime = parseTimeToMinutes(todaySpecialHours.open);
                const closeTime = parseTimeToMinutes(todaySpecialHours.close);

                if (openTime !== null && closeTime !== null && closeTime > openTime) {
                    if (currentTime < openTime) {
                        return buildLocationStatus(false, todaySpecialHours.open, null);
                    }

                    if (currentTime <= closeTime) {
                        return buildLocationStatus(true, null, todaySpecialHours.close);
                    }
                }
            }
        }

        if (!location.hours) {
            return buildLocationStatus(false, null, null);
        }

        const todayHours = location.hours[todayKey] || location.hours[todayKey.toLowerCase()];
        if (!todayHours || typeof todayHours === 'string') {
            return buildLocationStatus(false, null, null);
        }

        if (todayHours.open && todayHours.close) {
            const { currentTime } = getCurrentDayAndTime(timezone);
            const openTime = parseTimeToMinutes(todayHours.open);
            const closeTime = parseTimeToMinutes(todayHours.close);

            if (openTime !== null && closeTime !== null && closeTime > openTime) {
                if (currentTime < openTime) {
                    return buildLocationStatus(false, todayHours.open, null);
                }

                if (currentTime <= closeTime) {
                    return buildLocationStatus(true, null, todayHours.close);
                }
            }
        }

        return buildLocationStatus(false, null, null);
    }

    // Format address
    function formatAddress(address) {
        if (!address) return '';

        const street = address.street || address.address1 || address.line1 || '';
        const city = address.city || '';
        const state = address.state || '';
        const zip = address.zip || address.postal_code || '';

        return `${street}, ${city}, ${state} ${zip}`.trim();
    }

    // Format city and state
    function formatCityState(address) {
        if (!address) return '';

        const city = address.city || '';
        const state = address.state || '';

        if (city && state) {
            return `${city}, ${state}`;
        } else if (city) {
            return city;
        } else if (state) {
            return state;
        }

        return '';
    }

    // Format phone number
    function formatPhone(phone) {
        if (!phone) return '';

        // Remove all non-digit characters
        const cleaned = phone.replace(/\D/g, '');

        // Format as (XXX) XXX-XXXX for 10 digit numbers
        if (cleaned.length === 10) {
            return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
        }

        // Return original if not 10 digits
        return phone;
    }

    // Render location button
    function renderLocationButton() {
        const locationStatus = selectedLocation ? getLocationHoursStatus(selectedLocation) : buildLocationStatus(false, null, null);

        let cityStateText = '';
        if (config.showCityState && selectedLocation && selectedLocation.address) {
            const cityState = formatCityState(selectedLocation.address);
            if (cityState) {
                cityStateText = `<span class="mighty-location-selector-city-state">${cityState}</span>`;
            }
        }

        let phoneText = '';
        if (config.showPhone && selectedLocation && selectedLocation.phone) {
            const formattedPhone = formatPhone(selectedLocation.phone);
            phoneText = `<a href="tel:${selectedLocation.phone}" class="mighty-location-selector-phone" onclick="event.stopPropagation()">${formattedPhone}</a>`;
        }

        let hoursText = '';
        if (config.showHours && selectedLocation) {
            hoursText = `<span class="mighty-location-selector-hours ${locationStatus.isOpen ? 'open' : 'closed'}">${locationStatus.displayText}</span>`;
        }

        return `
            <button class="mighty-location-button" onclick="window.MightyLocationSelector.toggleModal()">
                <svg class="mighty-location-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
                </svg>
                <div class="mighty-location-selector-content">
                    ${selectedLocation ? `
                        <span class="mighty-location-selector-name">${selectedLocation.name}</span>
                        ${cityStateText}
                        ${phoneText}
                        ${hoursText}
                    ` : `
                        <span class="mighty-location-selector-label">Select Your</span>
                        <span class="mighty-location-selector-name">Store Location</span>
                    `}
                </div>
                <svg class="mighty-location-chevron" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
            </button>
        `;
    }

    // Render location modal
    function renderLocationModal() {
        const listHtml = locations.map(location => {
            const locationStatus = getLocationHoursStatus(location);
            const isSelected = selectedLocation && selectedLocation.id === location.id;

            const hoursHtml = locationStatus.isOpen && locationStatus.closesAt ? `
                <p class="mighty-location-item-hours open-until">
                    ${locationStatus.displayText}
                    ${location.slug ? ` • <a href="/apps/pages/locations/${location.slug}" class="mighty-location-details-link" onclick="event.stopPropagation()">Location Details</a>` : ''}
                </p>
            ` : (!locationStatus.isOpen && locationStatus.opensAt ? `
                <p class="mighty-location-item-hours opens-at">
                    ${locationStatus.displayText}
                    ${location.slug ? ` • <a href="/apps/pages/locations/${location.slug}" class="mighty-location-details-link" onclick="event.stopPropagation()">Location Details</a>` : ''}
                </p>
            ` : (location.slug ? `
                <p class="mighty-location-item-hours">
                    <a href="/apps/pages/locations/${location.slug}" class="mighty-location-details-link" onclick="event.stopPropagation()">Location Details</a>
                </p>
            ` : ''));

            return `
                <div class="mighty-location-item ${isSelected ? 'mighty-location-selected' : ''}" onclick="window.MightyLocationSelector.selectLocation(${location.id})">
                    <div class="mighty-location-item-header">
                        <h3 class="mighty-location-item-name">${location.name}</h3>
                        <span class="mighty-location-item-status ${locationStatus.isOpen ? 'open' : 'closed'}">
                            ${locationStatus.isOpen ? 'Open' : 'Closed'}
                        </span>
                    </div>
                    <p class="mighty-location-item-address">${formatAddress(location.address)}</p>
                    ${hoursHtml}
                </div>
            `;
        }).join('');

        return `
            <div class="mighty-location-modal-overlay" onclick="window.MightyLocationSelector.closeModal()"></div>
            <div class="mighty-location-modal">
                <div class="mighty-location-modal-header">
                    <h2 class="mighty-location-modal-title">Select Your Store</h2>
                    <button class="mighty-location-modal-close" onclick="window.MightyLocationSelector.closeModal()" aria-label="Close location selector">&times;</button>
                </div>
                <div class="mighty-location-modal-body">
                    <div class="mighty-location-list">
                        ${listHtml}
                    </div>
                </div>
            </div>
        `;
    }

    // Load selected location from localStorage
    function loadSelectedLocation() {
        try {
            const stored = localStorage.getItem('mighty_selected_location');
            if (stored) {
                const locationId = parseInt(stored);
                selectedLocation = locations.find(loc => loc.id === locationId);
            }

            // If no stored location or not found, select first location
            if (!selectedLocation && locations.length > 0) {
                if (config.defaultLocationId) {
                    selectedLocation = locations.find(loc => loc.id === config.defaultLocationId);
                }
                if (!selectedLocation) {
                    selectedLocation = locations[0];
                }
            }

            // Sync initial selection with Metastock
            if (selectedLocation && selectedLocation.shopify_id) {
                syncMetastockLocation(selectedLocation.shopify_id);
            }
        } catch (e) {
            // localStorage not available
            if (locations.length > 0) {
                selectedLocation = locations[0];

                // Sync initial selection with Metastock
                if (selectedLocation && selectedLocation.shopify_id) {
                    syncMetastockLocation(selectedLocation.shopify_id);
                }
            }
        }
    }

    // Save selected location to localStorage
    function saveSelectedLocation(locationId) {
        try {
            localStorage.setItem('mighty_selected_location', locationId);
        } catch (e) {
            // localStorage not available
        }
    }

    // Cache locations data
    function cacheLocations(locationsData) {
        try {
            const cacheData = {
                locations: locationsData,
                timestamp: Date.now(),
                shopDomain: config.shopDomain
            };
            localStorage.setItem('mighty_locations_cache', JSON.stringify(cacheData));
        } catch (e) {
            // localStorage not available or full
        }
    }

    // Load cached locations
    function loadCachedLocations() {
        try {
            const cached = localStorage.getItem('mighty_locations_cache');
            if (!cached) return null;

            const cacheData = JSON.parse(cached);

            // Check if cache is for the same shop
            if (cacheData.shopDomain !== config.shopDomain) {
                return null;
            }

            // Check if cache is less than 1 hour old (3600000 ms)
            const cacheAge = Date.now() - cacheData.timestamp;
            if (cacheAge > 3600000) {
                return null;
            }

            return cacheData.locations;
        } catch (e) {
            return null;
        }
    }

    // Toggle modal
    function toggleModal() {
        const overlay = document.querySelector('.mighty-location-modal-overlay');
        const modal = document.querySelector('.mighty-location-modal');
        const button = document.querySelector('.mighty-location-button');

        if (overlay && modal) {
            const isActive = overlay.classList.contains('active');

            if (isActive) {
                overlay.classList.remove('active');
                modal.classList.remove('active');
                button.classList.remove('active');
            } else {
                overlay.classList.add('active');
                modal.classList.add('active');
                button.classList.add('active');
            }
        }
    }

    // Close modal
    function closeModal() {
        const overlay = document.querySelector('.mighty-location-modal-overlay');
        const modal = document.querySelector('.mighty-location-modal');
        const button = document.querySelector('.mighty-location-button');

        if (overlay && modal) {
            overlay.classList.remove('active');
            modal.classList.remove('active');
            button.classList.remove('active');
        }
    }

    // Sync location with Metastock inventory system
    function syncMetastockLocation(shopifyLocationId) {
        // Validate input
        if (!shopifyLocationId) {
            console.warn('⚠️ MightyLocal: Location missing shopify_id - Metastock sync skipped');
            return false;
        }

        // Check if Metastock is loaded on this page
        if (typeof metastock_locations === 'undefined') {
            // This is normal on pages without inventory (home, about, etc.)
            return false;
        }

        // Normalize ID to string (Metastock stores IDs as strings)
        const locationId = String(shopifyLocationId);

        // Verify the location exists in Metastock
        const metastockLocation = metastock_locations.find(loc =>
            String(loc.id) === locationId
        );

        if (!metastockLocation) {
            console.error(
                `❌ MightyLocal: Location ID ${locationId} not found in Metastock.`,
                'Available IDs:', metastock_locations.map(l => l.id)
            );
            return false;
        }

        try {
            // 1. Read Metastock's localStorage
            let metastockStorage = JSON.parse(
                localStorage.getItem('metastock_user')
            ) || {};

            // 2. Update the location_id field
            metastockStorage.location_id = locationId;

            // 3. Save back to localStorage
            localStorage.setItem('metastock_user', JSON.stringify(metastockStorage));

            // 4. Dispatch Metastock's update event
            // This triggers all Metastock UI components to refresh automatically
            document.dispatchEvent(new CustomEvent('MetastockLocationUpdated', {
                detail: locationId
            }));

            console.log('✅ MightyLocal → Metastock sync:', metastockLocation.name);
            return true;

        } catch (error) {
            console.error('❌ MightyLocal: Failed to sync Metastock location:', error);
            return false;
        }
    }

    // Select location
    function selectLocation(locationId) {
        selectedLocation = locations.find(loc => loc.id === locationId);
        if (selectedLocation) {
            saveSelectedLocation(locationId);
            render();
            closeModal();

            // Sync with Metastock inventory system
            if (selectedLocation.shopify_id) {
                syncMetastockLocation(selectedLocation.shopify_id);
            }
        }
    }

    // Handle Metastock location changes (bidirectional sync)
    function handleMetastockUpdate(event) {
        // Get the new location ID from Metastock
        const metastockLocationId = String(event.detail);

        // Find matching location by shopify_id
        const matchingLocation = locations.find(loc =>
            String(loc.shopify_id) === metastockLocationId
        );

        if (!matchingLocation) {
            return; // Location not found in our system
        }

        // Check if this is already the selected location (prevent unnecessary updates)
        if (selectedLocation && selectedLocation.id === matchingLocation.id) {
            return; // Already selected, no need to update
        }

        // Update the selected location
        selectedLocation = matchingLocation;
        saveSelectedLocation(matchingLocation.id);
        render();

        console.log('✅ Metastock → MightyLocal sync:', matchingLocation.name);
    }

    // Render widget
    function render() {
        if (hasDesktopContainer) {
            renderDesktop();
        }
        if (hasMobileContainer) {
            renderMobile();
        }
    }

    // Render desktop version
    function renderDesktop() {
        const container = document.getElementById('mighty-location-selector');
        if (!container) return;

        container.innerHTML = `
            <div class="mighty-location-selector">
                ${renderLocationButton()}
                ${renderLocationModal()}
            </div>
        `;
    }

    // Render mobile button
    function renderMobileButton() {
        const locationStatus = selectedLocation ? getLocationHoursStatus(selectedLocation) : buildLocationStatus(false, null, null);

        let statusText = '';
        let statusClass = '';
        if (selectedLocation) {
            statusText = locationStatus.displayText;
            statusClass = locationStatus.isOpen ? 'open' : 'closed';
        }

        return `
            <button class="mighty-location-mobile-button" onclick="window.MightyLocationSelector.toggleMobileFlyout()">
                <div class="mighty-location-mobile-left">
                    <svg class="mighty-location-mobile-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
                    </svg>
                    <div class="mighty-location-mobile-info">
                        <span class="mighty-location-mobile-name">${selectedLocation ? selectedLocation.name : 'Select Location'}</span>
                        ${statusText ? `<span class="mighty-location-mobile-status ${statusClass}">${statusText}</span>` : ''}
                    </div>
                </div>
                <svg class="mighty-location-mobile-chevron" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                </svg>
            </button>
        `;
    }

    // Render mobile flyout
    function renderMobileFlyout() {
        if (!selectedLocation) {
            return renderMobileLocationSelection();
        }

        const locationStatus = getLocationHoursStatus(selectedLocation);
        const todayContext = getLocationTodayContext(selectedLocation);
        const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

        let hoursText = '';
        let hoursClass = '';
        hoursText = locationStatus.displayText;
        hoursClass = locationStatus.isOpen ? 'open' : 'closed';

        // Format directions URL
        const address = formatAddress(selectedLocation.address);
        const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;

        // Get today's date for special hours check
        const todayDate = todayContext.todayDate;

        // Build hours list
        const hoursListHtml = days.map(day => {
            const dayLower = day.toLowerCase();
            const dayHours = selectedLocation.hours && selectedLocation.hours[dayLower];
            let timeText = 'Closed';
            let hasSpecialHours = false;

            const isToday = day === todayContext.todayName;

            // Check for special hours if it's today
            if (isToday && selectedLocation.today_special_hours) {
                const specialHours = selectedLocation.today_special_hours;
                hasSpecialHours = true;

                if (specialHours.is_closed || specialHours.status === 'closed') {
                    timeText = 'Closed';
                } else if (specialHours.open && specialHours.close) {
                    timeText = `${specialHours.open} - ${specialHours.close}`;
                }
            } else if (dayHours) {
                // Regular hours
                if (typeof dayHours === 'string') {
                    timeText = dayHours;
                } else if (dayHours.open && dayHours.close) {
                    timeText = `${dayHours.open} - ${dayHours.close}`;
                }
            }

            return `
                <div class="mighty-location-mobile-hours-item ${isToday ? 'today' : ''}">
                    <span class="mighty-location-mobile-hours-day">${day}${isToday ? ' (Today)' : ''}${isToday && hasSpecialHours ? ' ⚠' : ''}</span>
                    <span class="mighty-location-mobile-hours-time">${timeText}</span>
                </div>
            `;
        }).join('');

        return `
            <div class="mighty-location-mobile-flyout-overlay" onclick="window.MightyLocationSelector.closeMobileFlyout()"></div>
            <div class="mighty-location-mobile-flyout">
                <div class="mighty-location-mobile-flyout-header">
                    <h2 class="mighty-location-mobile-flyout-title">Your Store</h2>
                    <button class="mighty-location-mobile-flyout-close" onclick="window.MightyLocationSelector.closeMobileFlyout()" aria-label="Close store menu">&times;</button>
                </div>
                <div class="mighty-location-mobile-flyout-body">
                    <div class="mighty-location-mobile-current" id="mobile-current-view">
                        <div class="mighty-location-mobile-current-label">Current Location</div>
                        <div class="mighty-location-mobile-current-card">
                            <h3 class="mighty-location-mobile-current-name">${selectedLocation.name}</h3>
                            <p class="mighty-location-mobile-current-address">${address}</p>
                            <p class="mighty-location-mobile-current-hours ${hoursClass}">${hoursText}</p>

                            <div class="mighty-location-mobile-actions">
                                <a href="tel:${selectedLocation.phone}" class="mighty-location-mobile-action-btn">
                                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                                    </svg>
                                    Call
                                </a>
                                <a href="${directionsUrl}" target="_blank" class="mighty-location-mobile-action-btn">
                                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"/>
                                    </svg>
                                    Directions
                                </a>
                            </div>

                            <button class="mighty-location-mobile-view-hours-btn" onclick="window.MightyLocationSelector.toggleMobileHours()">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                                </svg>
                                <span id="mobile-hours-btn-text">View Store Hours</span>
                            </button>

                            <div class="mighty-location-mobile-hours-display" id="mobile-hours-display">
                                <h4 class="mighty-location-mobile-hours-title">Store Hours</h4>
                                <div class="mighty-location-mobile-hours-list">
                                    ${hoursListHtml}
                                </div>
                            </div>
                        </div>

                        <button class="mighty-location-mobile-change-btn" onclick="window.MightyLocationSelector.showMobileLocationSelection()">
                            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"/>
                            </svg>
                            Change Location
                        </button>
                    </div>

                    <div class="mighty-location-mobile-selection" id="mobile-selection-view">
                        ${renderMobileLocationSelectionContent()}
                    </div>
                </div>
            </div>
        `;
    }

    // Render mobile location selection content
    function renderMobileLocationSelectionContent() {
        const listHtml = locations.map(location => {
            const locationStatus = getLocationHoursStatus(location);
            const isSelected = selectedLocation && selectedLocation.id === location.id;

            return `
                <div class="mighty-location-mobile-list-item ${isSelected ? 'mighty-location-selected' : ''}" onclick="window.MightyLocationSelector.selectLocationMobile(${location.id})">
                    <div class="mighty-location-mobile-list-item-header">
                        <h3 class="mighty-location-mobile-list-item-name">${location.name}</h3>
                        <span class="mighty-location-mobile-list-item-status ${locationStatus.isOpen ? 'open' : 'closed'}">
                            ${locationStatus.isOpen ? 'Open' : 'Closed'}
                        </span>
                    </div>
                    <p class="mighty-location-mobile-list-item-address">${formatAddress(location.address)}</p>
                </div>
            `;
        }).join('');

        return `
            <div class="mighty-location-mobile-selection-header">
                <button class="mighty-location-mobile-back-btn" onclick="window.MightyLocationSelector.hideMobileLocationSelection()" aria-label="Go back">
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
                    </svg>
                </button>
                <h3 class="mighty-location-mobile-selection-title">Select Store</h3>
            </div>
            <div class="mighty-location-mobile-list">
                ${listHtml}
            </div>
        `;
    }

    // Render mobile location selection (when no location selected)
    function renderMobileLocationSelection() {
        const listHtml = locations.map(location => {
            const locationStatus = getLocationHoursStatus(location);

            return `
                <div class="mighty-location-mobile-list-item" onclick="window.MightyLocationSelector.selectLocationMobile(${location.id})">
                    <div class="mighty-location-mobile-list-item-header">
                        <h3 class="mighty-location-mobile-list-item-name">${location.name}</h3>
                        <span class="mighty-location-mobile-list-item-status ${locationStatus.isOpen ? 'open' : 'closed'}">
                            ${locationStatus.isOpen ? 'Open' : 'Closed'}
                        </span>
                    </div>
                    <p class="mighty-location-mobile-list-item-address">${formatAddress(location.address)}</p>
                </div>
            `;
        }).join('');

        return `
            <div class="mighty-location-mobile-flyout-overlay" onclick="window.MightyLocationSelector.closeMobileFlyout()"></div>
            <div class="mighty-location-mobile-flyout">
                <div class="mighty-location-mobile-flyout-header">
                    <h2 class="mighty-location-mobile-flyout-title">Select Your Store</h2>
                    <button class="mighty-location-mobile-flyout-close" onclick="window.MightyLocationSelector.closeMobileFlyout()" aria-label="Close store menu">&times;</button>
                </div>
                <div class="mighty-location-mobile-flyout-body">
                    <div class="mighty-location-mobile-list">
                        ${listHtml}
                    </div>
                </div>
            </div>
        `;
    }

    // Render mobile version
    function renderMobile() {
        const container = document.getElementById('mighty-location-selector-mobile');
        if (!container) return;

        container.innerHTML = `
            <div class="mighty-location-selector-mobile">
                ${renderMobileButton()}
                ${renderMobileFlyout()}
            </div>
        `;
    }

    // Toggle mobile flyout
    function toggleMobileFlyout() {
        const overlay = document.querySelector('.mighty-location-mobile-flyout-overlay');
        const flyout = document.querySelector('.mighty-location-mobile-flyout');

        if (overlay && flyout) {
            const isActive = overlay.classList.contains('active');

            if (isActive) {
                overlay.classList.remove('active');
                flyout.classList.remove('active');
            } else {
                overlay.classList.add('active');
                flyout.classList.add('active');
            }
        }
    }

    // Close mobile flyout
    function closeMobileFlyout() {
        const overlay = document.querySelector('.mighty-location-mobile-flyout-overlay');
        const flyout = document.querySelector('.mighty-location-mobile-flyout');

        if (overlay && flyout) {
            overlay.classList.remove('active');
            flyout.classList.remove('active');

            // Reset views
            setTimeout(() => {
                hideMobileLocationSelection();
                const hoursDisplay = document.getElementById('mobile-hours-display');
                if (hoursDisplay) {
                    hoursDisplay.classList.remove('active');
                    const btnText = document.getElementById('mobile-hours-btn-text');
                    if (btnText) btnText.textContent = 'View Store Hours';
                }
            }, 300);
        }
    }

    // Toggle mobile hours display
    function toggleMobileHours() {
        const hoursDisplay = document.getElementById('mobile-hours-display');
        const btnText = document.getElementById('mobile-hours-btn-text');

        if (hoursDisplay) {
            const isActive = hoursDisplay.classList.contains('active');
            if (isActive) {
                hoursDisplay.classList.remove('active');
                if (btnText) btnText.textContent = 'View Store Hours';
            } else {
                hoursDisplay.classList.add('active');
                if (btnText) btnText.textContent = 'Hide Store Hours';
            }
        }
    }

    // Show mobile location selection
    function showMobileLocationSelection() {
        const currentView = document.getElementById('mobile-current-view');
        const selectionView = document.getElementById('mobile-selection-view');

        if (currentView && selectionView) {
            currentView.style.display = 'none';
            selectionView.classList.add('active');
        }
    }

    // Hide mobile location selection
    function hideMobileLocationSelection() {
        const currentView = document.getElementById('mobile-current-view');
        const selectionView = document.getElementById('mobile-selection-view');

        if (currentView && selectionView) {
            currentView.style.display = 'block';
            selectionView.classList.remove('active');
        }
    }

    // Select location from mobile
    function selectLocationMobile(locationId) {
        selectedLocation = locations.find(loc => loc.id === locationId);
        if (selectedLocation) {
            saveSelectedLocation(locationId);
            render();
            closeMobileFlyout();

            // Sync with Metastock inventory system
            if (selectedLocation.shopify_id) {
                syncMetastockLocation(selectedLocation.shopify_id);
            }
        }
    }

    // Process locations data
    function processLocationsData(data) {
        // Ensure we have a valid array
        // Note: Locations are already sorted by sort_order from the API
        if (Array.isArray(data.locations)) {
            return data.locations;
        } else if (data.locations && typeof data.locations === 'object') {
            return Object.values(data.locations);
        } else if (Array.isArray(data)) {
            return data;
        } else if (data && typeof data === 'object') {
            return Object.values(data);
        }
        return [];
    }

    function getMightyLocalLocations() {
        if (!window.mighty_local || !Object.prototype.hasOwnProperty.call(window.mighty_local, 'locations')) {
            return null;
        }

        return window.mighty_local.locations;
    }

    function showNoLocationsMessage() {
        if (hasDesktopContainer) {
            const desktopContainer = document.getElementById('mighty-location-selector');
            if (desktopContainer) {
                desktopContainer.innerHTML = '<div class="mighty-location-error"><p>No locations available.</p></div>';
            }
        }
        if (hasMobileContainer) {
            const mobileContainer = document.getElementById('mighty-location-selector-mobile');
            if (mobileContainer) {
                mobileContainer.innerHTML = '<div class="mighty-location-error"><p>No locations available.</p></div>';
            }
        }
    }

    // Fetch locations from API
    function fetchLocationsFromApi() {
        return MightyWidgetData.getLocations(config.shopDomain, config.apiBaseUrl || getApiBaseUrl()).then(processedLocations => {
            if (processedLocations.length > 0) {
                cacheLocations(processedLocations);
            }

            return processedLocations;
        });
    }

    // Fetch locations (with caching)
    function loadLocations() {
        const desktopContainer = document.getElementById('mighty-location-selector');
        const mobileContainer = document.getElementById('mighty-location-selector-mobile');

        hasDesktopContainer = !!desktopContainer;
        hasMobileContainer = !!mobileContainer;

        if (!hasDesktopContainer && !hasMobileContainer) {
            console.error('Mighty Local: No container elements found');
            return;
        }

        const mightyLocalLocations = getMightyLocalLocations();

        if (typeof mightyLocalLocations !== 'undefined' && mightyLocalLocations !== null && mightyLocalLocations !== false) {
            locations = processLocationsData(mightyLocalLocations);

            if (locations.length === 0) {
                showNoLocationsMessage();
                return;
            }

            cacheLocations(locations);
            loadSelectedLocation();
            render();
            return;
        }

        // Try to load from cache first
        const cachedLocations = loadCachedLocations();

        if (cachedLocations && cachedLocations.length > 0) {
            // Use cached data immediately (no loading message!)
            locations = cachedLocations;
            loadSelectedLocation();
            render();
/*
            // Fetch fresh data in background to keep cache updated
            fetchLocationsFromApi()
                .then(freshLocations => {
                    if (freshLocations.length > 0) {
                        locations = freshLocations;
                        loadSelectedLocation();
                        render();
                    }
                })
                .catch(error => {
                    console.warn('Background location refresh failed:', error);
                    // Keep using cached data, no error shown to user
                });
 */
        } else {
            // No cache available, show loading message
            if (hasDesktopContainer) {
                desktopContainer.innerHTML = '<div class="mighty-location-loading"><p>Loading locations...</p></div>';
            }
            if (hasMobileContainer) {
                mobileContainer.innerHTML = '<div class="mighty-location-loading"><p>Loading locations...</p></div>';
            }

            fetchLocationsFromApi()
                .then(freshLocations => {
                    locations = freshLocations;

                    if (locations.length === 0) {
                        showNoLocationsMessage();
                        return;
                    }

                    loadSelectedLocation();
                    render();
                })
                .catch(error => {
                    console.error('Error loading locations:', error);
                    if (hasDesktopContainer) {
                        const desktopContainer = document.getElementById('mighty-location-selector');
                        if (desktopContainer) {
                            desktopContainer.innerHTML = '<div class="mighty-location-error"><p>Unable to load locations.</p></div>';
                        }
                    }
                    if (hasMobileContainer) {
                        const mobileContainer = document.getElementById('mighty-location-selector-mobile');
                        if (mobileContainer) {
                            mobileContainer.innerHTML = '<div class="mighty-location-error"><p>Unable to load locations.</p></div>';
                        }
                    }
                });
        }
    }

    // Clear locations cache
    function clearCache() {
        try {
            localStorage.removeItem('mighty_locations_cache');
            console.log('✅ Mighty Local: Cache cleared');
        } catch (e) {
            console.warn('⚠️ Mighty Local: Could not clear cache');
        }
    }

    // Public API
    window.MightyLocationSelector = {
        // Desktop functions
        toggleModal,
        closeModal,
        selectLocation,
        // Mobile functions
        toggleMobileFlyout,
        closeMobileFlyout,
        toggleMobileHours,
        showMobileLocationSelection,
        hideMobileLocationSelection,
        selectLocationMobile,
        // Shared functions
        getSelectedLocation: () => selectedLocation,
        refresh: loadLocations,
        clearCache: clearCache, // Clear cached locations
        syncMetastock: syncMetastockLocation // For debugging/testing
    };

    // Initialize
    function init() {
        injectStyles();
        loadLocations();

        // Listen for Metastock location changes (bidirectional sync)
        document.addEventListener('MetastockLocationUpdated', handleMetastockUpdate);
    }

    // Initialize when ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    }


    function run_locationsFooter() {
        setMightyWidgetVariables(document.getElementById((window.MightyLocationsConfig || {}).containerId || 'mighty-locations-section'), (window.MightyLocationsConfig || {}).theme || 'dark');
'use strict';

    // Prevent conflicts with existing scripts
    if (window.MightyLocalLocationsLoaded) {
        return;
    }
    window.MightyLocalLocationsLoaded = true;


    // Configuration
    const userConfig = window.MightyLocationsConfig || {};
    const config = {
        shopDomain: userConfig.shopDomain || window.Shopify?.shop || window.location.hostname.replace('www.', ''),
        theme: userConfig.theme || 'dark',
        defaultExpanded: userConfig.defaultExpanded,
        showEmail: userConfig.showEmail !== false,
        showPhone: userConfig.showPhone !== false,
        showHours: userConfig.showHours !== false,
        containerId: userConfig.containerId || 'mighty-locations-section',
        apiBaseUrl: userConfig.apiBaseUrl || MightyPublicApi.baseUrl
    };

    let locations = [];
    let expandedLocations = new Set();

    // Inject CSS styles
    function injectStyles() {
        return;
    }

    // Format phone number
    function formatPhone(phone) {
        if (!phone) return '';
        // Remove all non-numeric characters
        const cleaned = phone.replace(/\D/g, '');
        // Format as (XXX)XXX-XXXX
        if (cleaned.length === 10) {
            return `(${cleaned.slice(0, 3)})${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
        }
        return phone; // Return original if not 10 digits
    }

    // Format hours
    function formatHours(hours) {
        if (!hours || typeof hours !== 'object') return '';

        const daysOrder = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
        const daysShort = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

        let hoursHtml = '<div class="mighty-location-hours">';

        daysOrder.forEach((day, index) => {
            const dayHours = hours[day] || hours[day.toLowerCase()];
            let timeDisplay = 'CLOSED';

            if (dayHours) {
                if (typeof dayHours === 'string') {
                    timeDisplay = dayHours;
                } else if (dayHours.open && dayHours.close) {
                    timeDisplay = `${dayHours.open} - ${dayHours.close}`;
                } else if (dayHours.closed === false || dayHours.is_open === true) {
                    timeDisplay = dayHours.hours || 'Open';
                }
            }

            hoursHtml += `
                <div class="mighty-location-hours-row">
                    <span class="mighty-location-day">${daysShort[index]}:</span>
                    <span class="mighty-location-time">${timeDisplay}</span>
                </div>
            `;
        });

        hoursHtml += '</div>';
        return hoursHtml;
    }

    // Create location card HTML
    function createLocationCard(location, isExpandable) {
        const isExpanded = expandedLocations.has(location.id) || (!isExpandable && config.defaultExpanded !== false);
        const expandedClass = isExpanded ? 'expanded' : '';

        const address = location.address || {};
        const fullAddress = [
            address.street || address.address1 || address.line1,
            address.city,
            address.state,
            address.zip || address.postal_code
        ].filter(Boolean).join(', ');

        return `
            <div class="mighty-location-card ${isExpandable ? 'expandable' : ''} ${expandedClass}" data-location-id="${location.id}">
                <div class="mighty-location-header">
                    <h3 class="mighty-location-title">${location.name || 'Store Location'}</h3>
                    ${isExpandable ? '<div class="mighty-location-toggle">▼</div>' : ''}
                </div>
                <div class="mighty-location-content ${expandedClass}">
                    ${fullAddress ? `
                        <div class="mighty-location-info">
                            <div class="mighty-location-label">Store Address & Hours</div>
                            <p class="mighty-location-address">${fullAddress}</p>
                        </div>
                    ` : ''}

                    ${config.showHours && location.hours ? `
                        <div class="mighty-location-info">
                            ${formatHours(location.hours)}
                        </div>
                    ` : ''}

                    ${(config.showPhone && location.phone) || (config.showEmail && location.email) ? `
                        <div class="mighty-location-info">
                            ${config.showPhone && location.phone ? `
                                <a href="tel:${location.phone}" class="mighty-location-contact">
                                    ${formatPhone(location.phone)}
                                </a>
                            ` : ''}
                            ${config.showEmail && location.email ? `
                                <a href="mailto:${location.email}" class="mighty-location-contact">
                                    ${location.email}
                                </a>
                            ` : ''}
                        </div>
                    ` : ''}
                </div>
            </div>
        `;
    }

    // Toggle location expansion
    function toggleLocation(locationId) {
        if (expandedLocations.has(locationId)) {
            expandedLocations.delete(locationId);
        } else {
            expandedLocations.add(locationId);
        }

        const card = document.querySelector(`[data-location-id="${locationId}"]`);
        if (card) {
            const content = card.querySelector('.mighty-location-content');
            card.classList.toggle('expanded');
            content.classList.toggle('expanded');
        }
    }

    // Attach event listeners
    function attachEventListeners() {
        const cards = document.querySelectorAll('.mighty-location-card.expandable');
        cards.forEach(card => {
            const locationId = card.getAttribute('data-location-id');
            const header = card.querySelector('.mighty-location-header');

            header.addEventListener('click', () => {
                toggleLocation(locationId);
            });
        });
    }

    // Render locations
    function renderLocations(locations) {
        if (locations.length === 0) {
            return '<div class="mighty-locations-error"><p>No locations available.</p></div>';
        }

        const isExpandable = locations.length > 1 && config.defaultExpanded !== true;

        if (locations.length === 1) {
            // Single location - full width
            return `<div class="mighty-location-single">${createLocationCard(locations[0], false)}</div>`;
        } else {
            // Multiple locations - stacked vertically
            const locationsHtml = locations.map(loc => createLocationCard(loc, isExpandable)).join('');
            return `<div class="mighty-locations-grid">${locationsHtml}</div>`;
        }
    }

    function processLocationsData(data) {
        if (Array.isArray(data?.locations)) {
            return data.locations;
        } else if (data?.locations && typeof data.locations === 'object') {
            return Object.values(data.locations);
        } else if (Array.isArray(data)) {
            return data;
        } else if (data && typeof data === 'object') {
            return Object.values(data);
        }

        return [];
    }

    function getMightyLocalLocations() {
        if (!window.mighty_local || !Object.prototype.hasOwnProperty.call(window.mighty_local, 'locations')) {
            return null;
        }

        return window.mighty_local.locations;
    }

    function renderLocationsIntoContainer(container) {
        if (locations.length === 0) {
            container.innerHTML = '<div class="mighty-locations-error"><p>No locations available at this time.</p></div>';
            return;
        }

        const html = `
            <div class="mighty-locations-section">
                <div class="mighty-locations-container">
                    ${renderLocations(locations)}
                </div>
            </div>
        `;

        container.innerHTML = html;
        setTimeout(attachEventListeners, 100);
    }

    // Fetch and display locations
    function loadLocations() {
        const container = document.getElementById(config.containerId);
        if (!container) {
            console.error('Mighty Local: Container element not found. Please add <div id="mighty-locations-section"></div> to your page.');
            return;
        }

        const mightyLocalLocations = getMightyLocalLocations();

        if (typeof mightyLocalLocations !== 'undefined' && mightyLocalLocations !== null && mightyLocalLocations !== false) {
            locations = processLocationsData(mightyLocalLocations);
            renderLocationsIntoContainer(container);
            return;
        }

        container.innerHTML = '<div class="mighty-locations-loading"><p>Loading locations...</p></div>';

        MightyWidgetData.getLocations(config.shopDomain, config.apiBaseUrl)
            .then(data => {
                locations = processLocationsData(data);
                renderLocationsIntoContainer(container);
            })
            .catch(error => {
                console.error('Error loading locations:', error);
                container.innerHTML = `
                    <div class="mighty-locations-section">
                        <div class="mighty-locations-container">
                            <div class="mighty-locations-error">
                                <p>Unable to load locations. Please try again later.</p>
                            </div>
                        </div>
                    </div>
                `;
            });
        return;
    }

    // Initialize widget
    function init() {
        // Inject styles
        injectStyles();

        // Load locations
        loadLocations();
    }

    // Initialize when the page is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    }


    const widgets = [
        { shouldInit: () => document.getElementById((window.MightyOffersConfig || {}).containerId || 'mighty-offers-section'), init: run_offers },
        { shouldInit: () => document.getElementById((window.MightyEventsConfig || {}).containerId || 'mighty-events-section'), init: run_events },
        { shouldInit: () => document.getElementById((window.MightyAnnouncementsConfig || {}).containerId || 'mighty-announcements-section'), init: run_announcements },
        { shouldInit: () => document.getElementById((window.MightyFeaturedConfig || {}).containerId || 'mighty-featured-section'), init: run_featured },
        { shouldInit: () => document.getElementById((window.MightyCampaignConfig || {}).containerId || 'mighty-campaign-section'), init: run_campaign },
        { shouldInit: () => document.getElementById('mighty-location-selector') || document.getElementById('mighty-location-selector-mobile'), init: run_locationSelector },
        { shouldInit: () => document.getElementById((window.MightyLocationsConfig || {}).containerId || 'mighty-locations-section'), init: run_locationsFooter }
    ];

    function bootWidgets() {
        widgets.forEach(widget => {
            if (widget.shouldInit()) {
                widget.init();
            }
        });
    }

    window.MightyWidgets = {
        boot: bootWidgets,
        getLocations: () => MightyWidgetData.getLocations()
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bootWidgets);
    } else {
        bootWidgets();
    }
})();
